window.PerfumeCustomizer = window.PerfumeCustomizer || {};

// Individual customizer functionality
window.PerfumeCustomizer.Individual = {
  product: null,
  variantId: null,
  customization: {},

  // Save scroll position before opening modal
  savedScrollPosition: null,

  // Open customizer
  open: function (product, variantId, prefillText = null) {
    // Save current scroll position
    this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    // Lock body scroll
    document.body.classList.add('pc-modal-open');

    // Ensure Icons module is initialized
    if (window.PerfumeCustomizer && window.PerfumeCustomizer.Icons) {
      if (!window.PerfumeCustomizer.Icons.manifest || Object.keys(window.PerfumeCustomizer.Icons.manifest).length === 0) {
        console.log('Icons: Re-initializing Icons module...');
        window.PerfumeCustomizer.Icons.init();
      }
    }

    // Reload icon assignments when modal opens (in case they were updated)
    if (window.ICON_MANAGER_DATA && window.ICON_MANAGER_DATA.assignments) {
      console.log('Customizer: Reloading icon assignments on modal open...');
      // Trigger a reload of assignments by re-running the loader logic
      // The assignments should already be loaded, but we'll verify
      console.log('Customizer: Current assignments:', Object.keys(window.ICON_MANAGER_DATA.assignments).length, 'main categories');
      Object.entries(window.ICON_MANAGER_DATA.assignments).forEach(([mainCat, subcats]) => {
        console.log('Customizer: Main category', mainCat, 'has', Object.keys(subcats).length, 'subcategories');
        Object.keys(subcats).forEach(subcat => {
          console.log('Customizer: -', subcat, 'has', subcats[subcat]?.length || 0, 'icons');
        });
      });
    } else {
      console.warn('Customizer: ⚠️ No icon assignments found! Make sure icon-assignments-loader.liquid is running.');
    }
    this.product = product;
    this.variantId = variantId;

    // Initialize customization
    const assetsUrl = window.CUSTOMIZER_ASSETS_URL || 'https://cdn.shopify.com/s/files/1/0946/4859/8826/files/';
    this.customization = {
      atomizerColor: `${assetsUrl}pink-bottle.png`,
      atomizerColorName: 'Pink',
      textContent: prefillText || '',
      textFont: '',
      textSize: '16px',
      textColor: '#ffffff',
      textRotation: -90, // Text rotated -90 degrees (vertical - fixed, no manual rotation)
      textPosition: null, // Will be auto-centered in text zone
      iconCategory: '',
      iconFilename: '',
      iconUrl: '',
      iconSize: 60,
      iconPosition: { top: '220px', left: '42px' }, // FIXED auto-placement (bottom area)
      logoUrl: '',
      logoFile: null,
      logoFilename: ''
    };

    // Show modal
    const modal = document.getElementById('pc-individual-modal');
    if (modal) {
      modal.classList.add('active');

      // Ensure close button works on mobile
      setTimeout(() => {
        const closeButtons = modal.querySelectorAll('.pc-individual-close');
        closeButtons.forEach(btn => {
          // Remove existing listeners to avoid duplicates
          const newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);

          newBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.PerfumeCustomizer?.Individual?.close) {
              window.PerfumeCustomizer.Individual.close();
            }
          });

          newBtn.addEventListener('touchend', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.PerfumeCustomizer?.Individual?.close) {
              window.PerfumeCustomizer.Individual.close();
            }
          });
        });
      }, 50);
    }

    // Ensure Icons module is initialized
    if (window.PerfumeCustomizer && window.PerfumeCustomizer.Icons) {
      const manifest = window.PerfumeCustomizer.Icons.manifest || {};
      if (Object.keys(manifest).length === 0) {
        window.PerfumeCustomizer.Icons.init();
      }
    }

    // Initialize fonts
    this.updateFonts();

    // Initialize icon categories (with retry logic)
    this.initIconMainCategories();

    // Set white color as default selected
    setTimeout(() => {
      document.querySelectorAll('.pc-color-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      const whiteColorOption = document.querySelector('.pc-color-option[data-color="#FFFFFF"]');
      if (whiteColorOption) {
        whiteColorOption.classList.add('selected');
      }
    }, 100);

    // Set default icon grid background color to white
    const iconGrid = document.getElementById('pc-icon-grid');
    if (iconGrid) {
      iconGrid.style.backgroundColor = '#ffffff';
    }

    // Set default icon preview backgrounds to pink (default atomizer)
    this.updateIconPreviewBackgrounds('Pink');

    // Pre-fill text input if provided
    if (prefillText) {
      setTimeout(() => {
        const textInput = document.getElementById('pc-text');
        if (textInput) {
          textInput.value = prefillText;
          this.customization.textContent = prefillText;
        }
      }, 100);
    }

    // Update preview
    this.updatePreview();

    // Close all accordions first to ensure they start closed
    setTimeout(() => {
      const allContents = document.querySelectorAll('.pc-accordion-content');
      const allHeaders = document.querySelectorAll('.pc-accordion-header');
      allContents.forEach(content => {
        content.classList.remove('expanded');
        content.style.setProperty('max-height', '0', 'important');
        content.style.setProperty('padding', '0 16px', 'important');
        content.style.setProperty('overflow', 'hidden', 'important');
      });
      allHeaders.forEach(header => {
        header.classList.remove('active');
      });
    }, 50);

    // Initialize accordion after modal opens
    setTimeout(() => {
      if (window.PerfumeCustomizer?.Individual?.initAccordion) {
        window.PerfumeCustomizer.Individual.initAccordion();
      }
    }, 200);

    // Also initialize on next frame to ensure DOM is ready
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (window.PerfumeCustomizer?.Individual?.initAccordion) {
          window.PerfumeCustomizer.Individual.initAccordion();
        }
      }, 50);
    });
  },

  // Close customizer
  close: function () {
    // Restore scroll position
    if (this.savedScrollPosition !== null) {
      window.scrollTo(0, this.savedScrollPosition);
      this.savedScrollPosition = null;
    }
    // Unlock body scroll
    document.body.classList.remove('pc-modal-open');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';

    const modal = document.getElementById('pc-individual-modal');
    if (modal) {
      modal.classList.remove('active');
    }

    // Close all accordions
    const allContents = document.querySelectorAll('.pc-accordion-content');
    const allHeaders = document.querySelectorAll('.pc-accordion-header');
    allContents.forEach(content => {
      content.classList.remove('expanded');
      content.style.maxHeight = '0';
      content.style.padding = '0 16px';
    });
    allHeaders.forEach(header => {
      header.classList.remove('active');
    });
  },

  // Reset all customizations
  reset: function () {
    if (confirm('Are you sure you want to reset all customizations?')) {
      // Revoke logo object URL if exists
      if (this.customization.logoUrl && this.customization.logoUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.customization.logoUrl);
      }
      // Reset customization
      const assetsUrl = window.CUSTOMIZER_ASSETS_URL || 'https://cdn.shopify.com/s/files/1/0946/4859/8826/files/';
      this.customization = {
        atomizerColor: `${assetsUrl}pink-bottle.png`,
        atomizerColorName: 'Pink',
        textContent: '',
        textFont: '',
        textSize: '16px',
        textColor: '#ffffff',
        textRotation: -90, // Fixed rotation
        textPosition: { top: '80px', left: '42px' }, // FIXED auto-placement
        iconCategory: '',
        iconFilename: '',
        iconUrl: '',
        iconSize: 60,
        iconPosition: { top: '220px', left: '42px' }, // FIXED auto-placement
        logoUrl: '',
        logoFile: null,
        logoFilename: ''
      };

      // Reset form inputs
      document.getElementById('pc-text').value = '';
      document.getElementById('pc-text-size').value = 16;
      document.getElementById('pc-icon-size').value = 60;
      document.getElementById('pc-icon-main-category').value = '';
      document.getElementById('pc-icon-subcategory').value = '';
      document.getElementById('pc-icon-subcategory').disabled = true;
      document.getElementById('pc-language').value = 'english';

      // Reset atomizer selection
      document.querySelectorAll('.pc-atomizer-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      document.querySelector('.pc-atomizer-option[data-color="pink"]').classList.add('selected');

      // Reset color selection to white
      document.querySelectorAll('.pc-color-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      const whiteColorOption = document.querySelector('.pc-color-option[data-color="#FFFFFF"]');
      if (whiteColorOption) {
        whiteColorOption.classList.add('selected');
      }

      // Clear icon grid
      document.getElementById('pc-icon-grid').innerHTML = '';

      // Clear logo preview
      this.hideLogoPreview();

      this.updatePreview();
    }
  },


  // Get background color for atomizer color name
  getAtomizerBackgroundColor: function (colorName) {
    const colorMap = {
      'Pink': '#FFB6C1',
      'Light Pink': '#FFC0CB',
      'Ivory': '#FFFFF0',
      'White': '#FFFFFF',
      'Gray': '#808080',
      'Blue': '#87CEEB',
      'Khaki': '#F0E68C',
      'Black': '#2F2F2F',
      'Red': '#FF6B6B'
    };
    return colorMap[colorName] || '#FFB6C1'; // Default to pink
  },

  // Update all icon preview box backgrounds to match atomizer color
  updateIconPreviewBackgrounds: function (colorName) {
    const bgColor = this.getAtomizerBackgroundColor(colorName);
    document.querySelectorAll('#pc-icon-grid .pc-icon-preview').forEach(iconPreview => {
      iconPreview.style.backgroundColor = bgColor;
    });
  },

  // Select atomizer color
  selectAtomizerColor: function (colorUrl, colorName) {
    this.customization.atomizerColor = colorUrl;
    this.customization.atomizerColorName = colorName;

    // Update selected state (both desktop and mobile)
    document.querySelectorAll('.pc-atomizer-option').forEach(opt => {
      opt.classList.remove('selected');
    });
    const selected = document.querySelectorAll(`.pc-atomizer-option[data-url="${colorUrl}"]`);
    selected.forEach(opt => {
      opt.classList.add('selected');
    });

    // Keep icon grid background white for better color visibility
    const iconGrid = document.getElementById('pc-icon-grid');
    if (iconGrid) {
      iconGrid.style.backgroundColor = '#ffffff';
    }

    // Update all icon preview box backgrounds to match atomizer color
    this.updateIconPreviewBackgrounds(colorName);

    // Update preview atomizer image
    const atomizerImg = document.getElementById('pc-preview-atomizer');
    if (atomizerImg) {
      atomizerImg.src = colorUrl;
      atomizerImg.style.opacity = '0';
      setTimeout(() => {
        atomizerImg.style.opacity = '1';
      }, 50);
    }

    this.updatePreview();
  },

  // Initialize main icon categories from config
  initIconMainCategories: function (retryCount = 0) {
    const select = document.getElementById('pc-icon-main-category');
    if (!select) {
      console.error('Icons: Main category dropdown not found in DOM');
      return;
    }

    // Check if config is loaded
    if (!window.CUSTOMIZER_ICONS) {
      console.warn(`Icons: CUSTOMIZER_ICONS config not found (attempt ${retryCount + 1})`);

      // Retry up to 5 times with 200ms delay
      if (retryCount < 5) {
        setTimeout(() => this.initIconMainCategories(retryCount + 1), 200);
      } else {
        console.error('Icons: Failed to load icon configuration after multiple attempts');
        // Add a visual error message to the dropdown
        const errorOption = document.createElement('option');
        errorOption.textContent = "Error loading icons";
        select.appendChild(errorOption);
      }
      return;
    }

    // Clear existing options except the first one
    while (select.options.length > 1) {
      select.remove(1);
    }

    // Get main categories from CUSTOMIZER_ICONS config
    const mainCategories = Object.keys(window.CUSTOMIZER_ICONS);

    if (mainCategories.length === 0) {
      console.warn('Icons: Config found but no categories defined');
      return;
    }

    mainCategories.forEach(categoryName => {
      const option = document.createElement('option');
      option.value = categoryName;
      option.textContent = categoryName;
      select.appendChild(option);
    });

    console.log('Icons: Successfully populated', mainCategories.length, 'main categories');
  },

  // Load subcategories when main category is selected
  loadSubcategories: function () {
    const mainCategory = document.getElementById('pc-icon-main-category')?.value;
    const subcategorySelect = document.getElementById('pc-icon-subcategory');
    const grid = document.getElementById('pc-icon-grid');

    if (!subcategorySelect) return;

    // Clear subcategory dropdown
    while (subcategorySelect.options.length > 1) {
      subcategorySelect.remove(1);
    }

    // Clear icon grid
    if (grid) {
      grid.innerHTML = '<p style="padding: 20px; text-align: center; color: #6b7280;">Please select a subcategory</p>';
    }

    if (!mainCategory) {
      subcategorySelect.disabled = true;
      return;
    }

    // Get subcategories from config
    if (window.CUSTOMIZER_ICONS && window.CUSTOMIZER_ICONS[mainCategory]) {
      const subcategories = Object.keys(window.CUSTOMIZER_ICONS[mainCategory]);
      subcategories.forEach(subcatKey => {
        const subcatData = window.CUSTOMIZER_ICONS[mainCategory][subcatKey];
        const option = document.createElement('option');
        option.value = subcatKey;
        option.textContent = subcatData.displayName || subcatKey;
        subcategorySelect.appendChild(option);
      });
      subcategorySelect.disabled = false;
      console.log('Icons: Loaded', subcategories.length, 'subcategories for', mainCategory);
    } else {
      subcategorySelect.disabled = true;
      console.warn('Icons: No subcategories found for', mainCategory);
    }
  },

  // Load icons from selected subcategory
  loadIconsFromSubcategory: function () {
    const mainCategory = document.getElementById('pc-icon-main-category')?.value;
    const subcategory = document.getElementById('pc-icon-subcategory')?.value;
    const grid = document.getElementById('pc-icon-grid');

    console.log('🔍 loadIconsFromSubcategory called');
    console.log('Main Category:', mainCategory);
    console.log('Subcategory:', subcategory);
    console.log('window.CUSTOMIZER_ICONS exists?', !!window.CUSTOMIZER_ICONS);

    if (!grid) {
      console.error('Icon grid element not found!');
      return;
    }

    if (!mainCategory || !subcategory) {
      grid.innerHTML = '<p style="padding: 20px; text-align: center; color: #6b7280;">Please select a category and subcategory</p>';
      return;
    }

    // Debug: Check if config is loaded
    if (!window.CUSTOMIZER_ICONS) {
      console.error('❌ window.CUSTOMIZER_ICONS is not defined!');
      console.error('Make sure customizer-config.js is loaded before customizer.js');
      grid.innerHTML = '<p style="padding: 20px; text-align: center; color: #dc2626;">Error: Icon config not loaded</p>';
      return;
    }

    // Debug: Log available main categories
    console.log('Available main categories:', Object.keys(window.CUSTOMIZER_ICONS));

    // Check if main category exists
    if (!window.CUSTOMIZER_ICONS[mainCategory]) {
      console.error('❌ Main category not found:', mainCategory);
      console.error('Available categories:', Object.keys(window.CUSTOMIZER_ICONS));
      grid.innerHTML = `<p style="padding: 20px; text-align: center; color: #dc2626;">Category "${mainCategory}" not found</p>`;
      return;
    }

    // Debug: Log available subcategories
    console.log('Available subcategories for', mainCategory + ':', Object.keys(window.CUSTOMIZER_ICONS[mainCategory]));

    // Check if subcategory exists
    if (!window.CUSTOMIZER_ICONS[mainCategory][subcategory]) {
      console.error('❌ Subcategory not found:', subcategory);
      console.error('Available subcategories:', Object.keys(window.CUSTOMIZER_ICONS[mainCategory]));
      grid.innerHTML = `<p style="padding: 20px; text-align: center; color: #dc2626;">Subcategory "${subcategory}" not found</p>`;
      return;
    }

    const subcatData = window.CUSTOMIZER_ICONS[mainCategory][subcategory];
    const iconFilenames = subcatData.icons || [];

    console.log('✅ Icons: Loading', iconFilenames.length, 'icons from', mainCategory, '>', subcategory);

    if (iconFilenames.length === 0) {
      grid.innerHTML = '<p style="padding: 20px; text-align: center; color: #6b7280;">No icons found in this subcategory</p>';
      return;
    }

    // Get current text color for icon coloring
    const currentColor = this.customization.textColor || '#ffffff';

    // Render icon grid
    grid.innerHTML = '';
    grid.style.display = 'grid';
    grid.style.gridTemplateColumns = 'repeat(auto-fill, minmax(60px, 1fr))';
    grid.style.gap = '8px';
    grid.style.padding = '8px';

    iconFilenames.forEach(iconFilename => {
      // Use dynamic asset URL if available, otherwise fallback to hardcoded (which might be wrong)
      const baseUrl = window.CUSTOMIZER_ASSETS_URL || 'https://cdn.shopify.com/s/files/1/0946/4859/8826/files/';
      const iconUrl = `${baseUrl}${iconFilename}`;

      // Create icon preview container
      const iconPreview = document.createElement('div');
      iconPreview.className = 'pc-icon-preview';
      iconPreview.style.cssText = `
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 1px solid #e5e7eb;
          border-radius: 4px;
          transition: all 0.2s ease;
          background-color: ${this.getAtomizerBackgroundColor(this.customization.atomizerColorName || 'Pink')};
        `;

      // Load and display SVG
      fetch(iconUrl)
        .then(response => response.text())
        .then(svgText => {
          iconPreview.innerHTML = svgText;
          const svg = iconPreview.querySelector('svg');
          if (svg) {
            svg.style.width = '40px';
            svg.style.height = '40px';
            svg.style.pointerEvents = 'none';
            // Apply current color
            svg.querySelectorAll('path, circle, rect, polygon').forEach(el => {
              el.setAttribute('fill', currentColor);
            });
          }
        })
        .catch(err => {
          console.warn('Failed to load icon:', iconFilename, err);
          iconPreview.innerHTML = '<span style="font-size: 10px; color: #999;">Error</span>';
        });

      // Click handler
      iconPreview.addEventListener('click', () => {
        this.selectIcon({
          category: `${mainCategory}/${subcategory}`,
          filename: iconFilename,
          url: iconUrl
        });

        // Visual feedback
        document.querySelectorAll('.pc-icon-preview').forEach(p => {
          p.style.borderColor = '#e5e7eb';
          p.style.borderWidth = '1px';
        });
        iconPreview.style.borderColor = '#6B1F3C';
        iconPreview.style.borderWidth = '2px';
      });

      // Hover effect
      iconPreview.addEventListener('mouseenter', () => {
        iconPreview.style.transform = 'scale(1.05)';
        iconPreview.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      });
      iconPreview.addEventListener('mouseleave', () => {
        iconPreview.style.transform = 'scale(1)';
        iconPreview.style.boxShadow = 'none';
      });

      grid.appendChild(iconPreview);
    });
  },

  // Select an icon
  selectIcon: function (iconData) {
    this.customization.iconCategory = iconData.category;
    this.customization.iconFilename = iconData.filename;
    // Use filename for iconUrl because loadIconSvg expects a filename and constructs the URL itself
    this.customization.iconUrl = iconData.filename;
    // Clear logo when icon is selected
    this.customization.logoUrl = '';
    this.customization.logoFile = null;
    this.customization.logoFilename = '';
    this.hideLogoPreview();
    // Update icon size slider if it exists
    const iconSizeInput = document.getElementById('pc-icon-size');
    if (iconSizeInput && iconSizeInput.value == 60) {
      // Keep default size
    }
    this.updatePreview();
  },

  // Handle logo upload
  handleLogoUpload: function (event) {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
    if (!validTypes.includes(file.type)) {
      alert('Please upload a valid image file (PNG, JPG, or SVG)');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('File size must be less than 5MB');
      return;
    }

    // Create object URL for preview
    const objectUrl = URL.createObjectURL(file);

    // Store logo data
    this.customization.logoUrl = objectUrl;
    this.customization.logoFile = file;
    this.customization.logoFilename = file.name;

    // Clear icon selection when logo is uploaded
    this.customization.iconCategory = '';
    this.customization.iconFilename = '';
    this.customization.iconUrl = '';
    document.getElementById('pc-icon-main-category').value = '';
    document.getElementById('pc-icon-subcategory').value = '';
    document.getElementById('pc-icon-subcategory').disabled = true;
    document.getElementById('pc-icon-grid').innerHTML = '';

    // Show logo preview
    this.showLogoPreview(objectUrl, file.name);

    // Update preview
    this.updatePreview();
  },

  // Show logo preview
  showLogoPreview: function (url, filename) {
    const preview = document.getElementById('pc-logo-preview');
    const previewImg = document.getElementById('pc-logo-preview-img');
    const filenameEl = document.getElementById('pc-logo-filename');

    if (preview && previewImg && filenameEl) {
      previewImg.src = url;
      filenameEl.textContent = filename;
      preview.style.display = 'block';
    }
  },

  // Hide logo preview
  hideLogoPreview: function () {
    const preview = document.getElementById('pc-logo-preview');
    const upload = document.getElementById('pc-logo-upload');

    if (preview) {
      preview.style.display = 'none';
    }
    if (upload) {
      upload.value = '';
    }
  },

  // Remove logo
  removeLogo: function () {
    // Revoke object URL to free memory
    if (this.customization.logoUrl && this.customization.logoUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.customization.logoUrl);
    }

    this.customization.logoUrl = '';
    this.customization.logoFile = null;
    this.customization.logoFilename = '';

    this.hideLogoPreview();
    this.updatePreview();
  },


  // Move text in specified direction - smooth, consistent movement within text zone
  // Note: Text is rotated -90 degrees, so directions are swapped
  // Only works when icon exists (text zone is active)
  moveText: function (direction) {
    console.log('moveText called with direction:', direction);
    const textPreview = document.getElementById('pc-preview-text');
    if (!textPreview) {
      console.error('moveText: textPreview element not found');
      return;
    }

    const hasIcon = !!(this.customization.logoUrl || (this.customization.iconUrl && window.PerfumeCustomizer && window.PerfumeCustomizer.Icons));

    const PRINT_AREA_WIDTH = 84;
    const PRINT_AREA_HEIGHT = 269;
    const MOVE_STEP = 5; // 5px per click for more noticeable movement

    // Get current position - prioritize stored position
    let currentTop, currentLeft;
    
    if (this.customization.textPosition) {
      currentTop = parseFloat(this.customization.textPosition.top);
      currentLeft = parseFloat(this.customization.textPosition.left);
    }
    
    // If not available, try inline style
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      currentTop = parseFloat(textPreview.style.top);
      currentLeft = parseFloat(textPreview.style.left);
    }
    
    // If still not available, try computed style
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      const computedStyle = window.getComputedStyle(textPreview);
      currentTop = parseFloat(computedStyle.top);
      currentLeft = parseFloat(computedStyle.left);
    }

    // If position still not set, use text zone center
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      const textZoneElement = document.getElementById('pc-text-zone');
      if (textZoneElement) {
        const zoneComputedStyle = window.getComputedStyle(textZoneElement);
        const style = textZoneElement.style;
        const textZoneTop = parseFloat(zoneComputedStyle.top) || parseFloat(style.top) || 0;
        const textZoneLeft = parseFloat(zoneComputedStyle.left) || parseFloat(style.left) || 0;
        const textZoneHeight = parseFloat(zoneComputedStyle.height) || parseFloat(style.height) || 179;
        const textZoneWidth = parseFloat(zoneComputedStyle.width) || parseFloat(style.width) || 84;
        currentTop = textZoneTop + textZoneHeight / 2;
        currentLeft = textZoneLeft + textZoneWidth / 2;
      } else {
        currentTop = 80;
        currentLeft = 42;
      }
    }

    // Calculate new position based on direction
    let newTop = currentTop;
    let newLeft = currentLeft;

    switch (direction) {
      case 'up':
        newTop = currentTop - MOVE_STEP;
        break;
      case 'down':
        newTop = currentTop + MOVE_STEP;
        break;
      case 'left':
        newLeft = currentLeft - MOVE_STEP;
        break;
      case 'right':
        newLeft = currentLeft + MOVE_STEP;
        break;
      default:
        return;
    }

    // Store position temporarily to allow enforceTextBoundaries to read it
    this.customization.textPosition = { top: newTop + 'px', left: newLeft + 'px', manual: true };

    // Disable transition temporarily for immediate positioning
    const originalTransition = textPreview.style.transition;
    textPreview.style.setProperty('transition', 'none', 'important');

    // Apply position with !important FIRST
    textPreview.style.setProperty('top', newTop + 'px', 'important');
    textPreview.style.setProperty('left', newLeft + 'px', 'important');
    textPreview.style.setProperty('transform', 'translate(-50%, -50%) rotate(-90deg)', 'important');
    
    // Force a reflow to ensure position is applied
    textPreview.offsetHeight;

    // NOW enforce boundaries - this will read the position we just set and constrain it
    let constrained = this.enforceTextBoundaries(textPreview, hasIcon);
    
    // If boundaries were enforced, apply the constrained position
    if (constrained) {
      // Apply constrained position with !important
      textPreview.style.setProperty('top', constrained.top + 'px', 'important');
      textPreview.style.setProperty('left', constrained.left + 'px', 'important');
      
      // Force reflow again
      textPreview.offsetHeight;
      
      // Verify it was applied - if not, force it again
      const appliedTop = parseFloat(textPreview.style.top);
      const appliedLeft = parseFloat(textPreview.style.left);
      if (Math.abs(appliedTop - constrained.top) > 0.1 || Math.abs(appliedLeft - constrained.left) > 0.1) {
        textPreview.style.setProperty('top', constrained.top + 'px', 'important');
        textPreview.style.setProperty('left', constrained.left + 'px', 'important');
        textPreview.offsetHeight;
      }
      
      // Update stored position with constrained values
      this.customization.textPosition = { top: constrained.top + 'px', left: constrained.left + 'px', manual: true };
    }
    
    // Restore transition after enforcement
    if (originalTransition && originalTransition !== 'none') {
      textPreview.style.setProperty('transition', originalTransition, 'important');
    }
  },

  // Enforce text boundaries - ensures text never goes outside defined text area
  enforceTextBoundaries: function (textPreview, hasIcon) {
    if (!textPreview) return null;

    // Get text zone element and read dimensions
    const textZoneElement = document.getElementById('pc-text-zone');
    if (!textZoneElement) {
      console.warn('enforceTextBoundaries: Text zone element not found');
      return null;
    }
    
    // Read text zone dimensions - use computed style to get actual rendered position (includes CSS overrides)
    const zoneComputedStyle = window.getComputedStyle(textZoneElement);
    const style = textZoneElement.style;
    // Use computed style for top/left (includes CSS overrides like mobile adjustments)
    // Fall back to inline style if computed is not available
    const TEXT_ZONE_TOP = parseFloat(zoneComputedStyle.top) || parseFloat(style.top) || 0;
    const TEXT_ZONE_LEFT = parseFloat(zoneComputedStyle.left) || parseFloat(style.left) || 0;
    const TEXT_ZONE_WIDTH = parseFloat(zoneComputedStyle.width) || parseFloat(style.width) || 84;
    const TEXT_ZONE_HEIGHT = parseFloat(zoneComputedStyle.height) || parseFloat(style.height) || 179;
    const TEXT_ZONE_BOTTOM = TEXT_ZONE_TOP + TEXT_ZONE_HEIGHT;
    const TEXT_ZONE_RIGHT = TEXT_ZONE_LEFT + TEXT_ZONE_WIDTH;

    // Get current position - try multiple sources for reliability
    let currentTop = parseFloat(textPreview.style.top);
    let currentLeft = parseFloat(textPreview.style.left);

    // If not in style, try stored position
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      if (this.customization.textPosition) {
        currentTop = parseFloat(this.customization.textPosition.top);
        currentLeft = parseFloat(this.customization.textPosition.left);
      }
    }
    
    // If still not available, try computed style
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      const computedStyle = window.getComputedStyle(textPreview);
      currentTop = parseFloat(computedStyle.top);
      currentLeft = parseFloat(computedStyle.left);
    }
    
    // If still not available, center in text zone
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      currentTop = TEXT_ZONE_TOP + TEXT_ZONE_HEIGHT / 2;
      currentLeft = TEXT_ZONE_LEFT + TEXT_ZONE_WIDTH / 2;
    }

    // Calculate text dimensions accurately
    // When text is rotated -90deg, we need to calculate based on the text's natural dimensions
    const textContent = this.customization.textContent || '';
    const textSize = parseInt(this.customization.textSize) || 16;
    
    // Get the actual font family from the text element
    const computedStyle = window.getComputedStyle(textPreview);
    const fontFamily = computedStyle.fontFamily || 'inherit';
    
    // Create a temporary element to measure actual text width (before rotation)
    // This gives us the most accurate measurement
    const tempMeasure = document.createElement('span');
    tempMeasure.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-size: ${textSize}px;
      font-family: ${fontFamily};
      padding: 0;
      margin: 0;
      line-height: 1.2;
    `;
    tempMeasure.textContent = textContent || 'M'; // Use 'M' if empty for minimum size
    document.body.appendChild(tempMeasure);
    
    // Measure the actual text width (this becomes height when rotated -90deg)
    const actualTextWidth = tempMeasure.offsetWidth || textSize;
    // Text height is the line height (approximately font size * line-height)
    const actualTextHeight = parseFloat(computedStyle.lineHeight) || (textSize * 1.2);
    
    // Clean up
    document.body.removeChild(tempMeasure);
    
    // When rotated -90deg:
    // - The text's natural width becomes its vertical height (rotatedTextHeight)
    // - The text's natural height becomes its horizontal width (rotatedTextWidth)
    const rotatedTextHeight = actualTextWidth;  // Natural width = vertical height when rotated
    const rotatedTextWidth = actualTextHeight;  // Natural height = horizontal width when rotated
    
    // Add safety margin to account for any rendering differences
    const finalTextHeight = rotatedTextHeight * 1.1; // 10% safety margin
    const finalTextWidth = rotatedTextWidth * 1.1;   // 10% safety margin

    // Calculate boundaries using ACTUAL measured dimensions
    // Text center must stay within zone, accounting for actual text dimensions
    const minTop = TEXT_ZONE_TOP + finalTextHeight / 2;
    const maxTop = TEXT_ZONE_BOTTOM - finalTextHeight / 2;
    const minLeft = TEXT_ZONE_LEFT + finalTextWidth / 2;
    const maxLeft = TEXT_ZONE_RIGHT - finalTextWidth / 2;
    
    // Ensure boundaries are valid (min <= max)
    const validMinTop = Math.min(minTop, maxTop);
    const validMaxTop = Math.max(minTop, maxTop);
    const validMinLeft = Math.min(minLeft, maxLeft);
    const validMaxLeft = Math.max(minLeft, maxLeft);

    // First check if current position is already valid - if so, don't adjust
    const textTopEdge = currentTop - finalTextHeight / 2;
    const textBottomEdge = currentTop + finalTextHeight / 2;
    const textLeftEdge = currentLeft - finalTextWidth / 2;
    const textRightEdge = currentLeft + finalTextWidth / 2;
    
    // Check if current position is within bounds
    const isTopValid = textTopEdge >= TEXT_ZONE_TOP;
    const isBottomValid = textBottomEdge <= TEXT_ZONE_BOTTOM;
    const isLeftValid = textLeftEdge >= TEXT_ZONE_LEFT;
    const isRightValid = textRightEdge <= TEXT_ZONE_RIGHT;
    
    // If position is already valid, return it without changes
    if (isTopValid && isBottomValid && isLeftValid && isRightValid) {
      return { top: currentTop, left: currentLeft };
    }

    // Position needs adjustment - constrain to valid boundaries
    let constrainedTop = Math.max(validMinTop, Math.min(validMaxTop, currentTop));
    let constrainedLeft = Math.max(validMinLeft, Math.min(validMaxLeft, currentLeft));
    
    // Double-check edges using actual measurements and force correction if needed
    const constrainedTopEdge = constrainedTop - finalTextHeight / 2;
    const constrainedBottomEdge = constrainedTop + finalTextHeight / 2;
    const constrainedLeftEdge = constrainedLeft - finalTextWidth / 2;
    const constrainedRightEdge = constrainedLeft + finalTextWidth / 2;
    
    // Force correction if any edge exceeds boundaries
    if (constrainedTopEdge < TEXT_ZONE_TOP) {
      constrainedTop = TEXT_ZONE_TOP + finalTextHeight / 2;
    }
    if (constrainedBottomEdge > TEXT_ZONE_BOTTOM) {
      constrainedTop = TEXT_ZONE_BOTTOM - finalTextHeight / 2;
    }
    if (constrainedLeftEdge < TEXT_ZONE_LEFT) {
      constrainedLeft = TEXT_ZONE_LEFT + finalTextWidth / 2;
    }
    if (constrainedRightEdge > TEXT_ZONE_RIGHT) {
      constrainedLeft = TEXT_ZONE_RIGHT - finalTextWidth / 2;
    }

    // Apply constrained position with !important to override any other styles
    // Temporarily disable transition for immediate positioning
    const originalTransition = textPreview.style.transition;
    textPreview.style.setProperty('transition', 'none', 'important');
    
    // Force apply the constrained position
    textPreview.style.setProperty('top', constrainedTop + 'px', 'important');
    textPreview.style.setProperty('left', constrainedLeft + 'px', 'important');
    textPreview.style.setProperty('transform', 'translate(-50%, -50%) rotate(-90deg)', 'important');
    
    // Force a reflow to ensure styles are applied
    textPreview.offsetHeight;
    
    // Verify and force again if needed - sometimes browser needs multiple attempts
    const appliedTop = parseFloat(textPreview.style.top);
    const appliedLeft = parseFloat(textPreview.style.left);
    
    // If position doesn't match, force it multiple times
    let attempts = 0;
    while ((Math.abs(appliedTop - constrainedTop) > 0.1 || Math.abs(appliedLeft - constrainedLeft) > 0.1) && attempts < 3) {
      textPreview.style.setProperty('top', constrainedTop + 'px', 'important');
      textPreview.style.setProperty('left', constrainedLeft + 'px', 'important');
      textPreview.offsetHeight; // Force reflow
      attempts++;
    }
    
    // Final verification - if still wrong, use direct style assignment as last resort
    if (Math.abs(parseFloat(textPreview.style.top) - constrainedTop) > 0.1) {
      textPreview.style.top = constrainedTop + 'px';
    }
    if (Math.abs(parseFloat(textPreview.style.left) - constrainedLeft) > 0.1) {
      textPreview.style.left = constrainedLeft + 'px';
    }
    
    // Restore transition after positioning
    if (originalTransition && originalTransition !== 'none') {
      textPreview.style.setProperty('transition', originalTransition, 'important');
    }
    
    // Update stored position
    if (this.customization.textPosition) {
      this.customization.textPosition.top = constrainedTop + 'px';
      this.customization.textPosition.left = constrainedLeft + 'px';
    }

    return { top: constrainedTop, left: constrainedLeft };
  },

  // Validate text position - checks if text is within text zone boundaries
  validateTextPosition: function () {
    // If no text content, skip validation
    if (!this.customization.textContent || !this.customization.textContent.trim()) {
      return { valid: true, message: 'No text to validate' };
    }

    // Get text zone element and text preview element
    const textZoneElement = document.getElementById('pc-text-zone');
    const textPreview = document.getElementById('pc-preview-text');

    if (!textZoneElement) {
      console.warn('validateTextPosition: Text zone element not found');
      return { valid: true, message: 'Text zone not found, skipping validation' };
    }

    if (!textPreview) {
      console.warn('validateTextPosition: Text preview element not found');
      return { valid: true, message: 'Text preview not found, skipping validation' };
    }

    // Read text zone dimensions - use computed style to get actual rendered position (includes CSS overrides)
    const zoneComputedStyle = window.getComputedStyle(textZoneElement);
    const style = textZoneElement.style;
    // Use computed style for top/left (includes CSS overrides like mobile adjustments)
    const TEXT_ZONE_TOP = parseFloat(zoneComputedStyle.top) || parseFloat(style.top) || 0;
    const TEXT_ZONE_LEFT = parseFloat(zoneComputedStyle.left) || parseFloat(style.left) || 0;
    const TEXT_ZONE_WIDTH = parseFloat(zoneComputedStyle.width) || parseFloat(style.width) || 84;
    const TEXT_ZONE_HEIGHT = parseFloat(zoneComputedStyle.height) || parseFloat(style.height) || 179;
    const TEXT_ZONE_BOTTOM = TEXT_ZONE_TOP + TEXT_ZONE_HEIGHT;
    const TEXT_ZONE_RIGHT = TEXT_ZONE_LEFT + TEXT_ZONE_WIDTH;

    // Get current position - try multiple sources for reliability
    let currentTop = parseFloat(textPreview.style.top);
    let currentLeft = parseFloat(textPreview.style.left);

    // If not in style, try stored position
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      if (this.customization.textPosition) {
        currentTop = parseFloat(this.customization.textPosition.top);
        currentLeft = parseFloat(this.customization.textPosition.left);
      }
    }
    
    // If still not available, try computed style
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      const computedStyle = window.getComputedStyle(textPreview);
      currentTop = parseFloat(computedStyle.top);
      currentLeft = parseFloat(computedStyle.left);
    }
    
    // If still not available, assume invalid
    if (isNaN(currentTop) || isNaN(currentLeft)) {
      return { 
        valid: false, 
        message: 'Text position could not be determined. Please adjust the text position.' 
      };
    }

    // Calculate text dimensions accurately (same logic as enforceTextBoundaries)
    const textContent = this.customization.textContent || '';
    const textSize = parseInt(this.customization.textSize) || 16;
    
    // Get the actual font family from the text element
    const computedStyle = window.getComputedStyle(textPreview);
    const fontFamily = computedStyle.fontFamily || 'inherit';
    
    // Create a temporary element to measure actual text width (before rotation)
    const tempMeasure = document.createElement('span');
    tempMeasure.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-size: ${textSize}px;
      font-family: ${fontFamily};
      padding: 0;
      margin: 0;
      line-height: 1.2;
    `;
    tempMeasure.textContent = textContent || 'M';
    document.body.appendChild(tempMeasure);
    
    // Measure the actual text width (this becomes height when rotated -90deg)
    const actualTextWidth = tempMeasure.offsetWidth || textSize;
    // Text height is the line height
    const actualTextHeight = parseFloat(computedStyle.lineHeight) || (textSize * 1.2);
    
    // Clean up
    document.body.removeChild(tempMeasure);
    
    // When rotated -90deg:
    // - The text's natural width becomes its vertical height (rotatedTextHeight)
    // - The text's natural height becomes its horizontal width (rotatedTextWidth)
    const rotatedTextHeight = actualTextWidth;  // Natural width = vertical height when rotated
    const rotatedTextWidth = actualTextHeight;  // Natural height = horizontal width when rotated
    
    // Add safety margin to account for any rendering differences
    const finalTextHeight = rotatedTextHeight * 1.1; // 10% safety margin
    const finalTextWidth = rotatedTextWidth * 1.1;   // 10% safety margin

    // Calculate all 4 edges of the text based on center position and dimensions
    const textTopEdge = currentTop - finalTextHeight / 2;
    const textBottomEdge = currentTop + finalTextHeight / 2;
    const textLeftEdge = currentLeft - finalTextWidth / 2;
    const textRightEdge = currentLeft + finalTextWidth / 2;

    // Check if all edges are within text zone boundaries
    const issues = [];
    if (textTopEdge < TEXT_ZONE_TOP) {
      issues.push('top');
    }
    if (textBottomEdge > TEXT_ZONE_BOTTOM) {
      issues.push('bottom');
    }
    if (textLeftEdge < TEXT_ZONE_LEFT) {
      issues.push('left');
    }
    if (textRightEdge > TEXT_ZONE_RIGHT) {
      issues.push('right');
    }

    if (issues.length > 0) {
      const edgeNames = issues.join(', ');
      return {
        valid: false,
        message: `Text is positioned outside the allowed area (${edgeNames} edge). Please adjust the text position using the arrow buttons or reduce the text size.`,
        edges: issues
      };
    }

    return { valid: true, message: 'Text is within allowed area' };
  },

  // Reset text position to default (automatic placement)
  resetTextPosition: function () {
    // Clear manual position flag to trigger automatic placement
    this.customization.textPosition = null;
    this.updatePreview();
  },

  // Toggle text zone visibility (for positioning/debugging)
  toggleTextZoneVisibility: function () {
    const textZone = document.getElementById('pc-text-zone');
    if (textZone) {
      const isHidden = textZone.style.display === 'none';
      textZone.style.display = isHidden ? 'block' : 'none';
      console.log('Text zone visibility:', isHidden ? 'shown' : 'hidden');
      return !isHidden; // Return new state
    }
    return false;
  },

  // Toggle font dropdown
  toggleFontDropdown: function () {
    const dropdownOptions = document.getElementById('pc-font-dropdown-options');
    if (dropdownOptions) {
      const isVisible = dropdownOptions.style.display === 'block';
      dropdownOptions.style.display = isVisible ? 'none' : 'block';

      if (!isVisible) {
        // Update fonts when opening dropdown
        this.updateFonts();
        // Close on outside click
        setTimeout(() => {
          document.addEventListener('click', function closeDropdown(e) {
            if (!e.target.closest('#pc-font-dropdown-button') && !e.target.closest('#pc-font-dropdown-options')) {
              dropdownOptions.style.display = 'none';
              document.removeEventListener('click', closeDropdown);
            }
          });
        }, 100);
      }
    }
  },

  // Update font options
  updateFonts: function () {
    const language = document.getElementById('pc-language')?.value || 'english';
    const dropdownOptions = document.getElementById('pc-font-dropdown-options');

    if (!dropdownOptions) {
      console.error('Font dropdown options container not found');
      return;
    }

    // Use the Fonts module to update dropdown with previews
    if (window.PerfumeCustomizer && window.PerfumeCustomizer.Fonts && window.PerfumeCustomizer.Fonts.updateDropdown) {
      // Ensure fonts are loaded first
      if (!window.PerfumeCustomizer.Fonts.fonts || Object.keys(window.PerfumeCustomizer.Fonts.fonts).length === 0) {
        console.log('Fonts not loaded yet, loading now...');
        dropdownOptions.innerHTML = '<div class="pc-font-loading">Loading fonts…</div>';
        window.PerfumeCustomizer.Fonts.loadFromSettings();
        setTimeout(() => this.updateFonts(), 200);
        return;
      }

      const availableFonts = window.PerfumeCustomizer.Fonts.getFonts(language);
      if (!availableFonts || availableFonts.length === 0) {
        dropdownOptions.innerHTML = '<div class="pc-font-loading">Loading fonts…</div>';
        setTimeout(() => this.updateFonts(), 200);
        return;
      }

      const self = this;
      try {
        window.PerfumeCustomizer.Fonts.updateDropdown(language, 'pc-font-dropdown-options', function (font, lang) {
          // Custom callback for individual modal
          const fontInput = document.getElementById('pc-font');
          const fontText = document.getElementById('pc-font-dropdown-text');
          if (fontInput) fontInput.value = font.family;
          if (fontText) {
            fontText.textContent = font.name;
            // Apply font correctly - extract font name for custom fonts to match @font-face
            if (font.type === 'custom' && font.family.includes(',')) {
              const fontName = font.family.split(',')[0].trim();
              const fallbacks = font.family.split(',').slice(1).map(f => f.trim()).join(', ');
              fontText.style.setProperty('font-family', `'${fontName}', ${fallbacks}`, 'important');
            } else {
              fontText.style.setProperty('font-family', font.family, 'important');
            }
          }
          if (dropdownOptions) dropdownOptions.style.display = 'none';
          self.updatePreview();
        });
      } catch (e) {
        console.error('Error updating font dropdown:', e);
        // Fallback: wait for fonts to load
        setTimeout(() => this.updateFonts(), 100);
      }
    } else {
      console.warn('Fonts module not available, waiting...');
      // Fallback: wait for fonts to load
      setTimeout(() => this.updateFonts(), 100);
    }
  },

  // Select color
  selectColor: function (color) {
    this.customization.textColor = color;

    // Update selected state for color options (both desktop and mobile)
    document.querySelectorAll('.pc-color-option').forEach(opt => {
      opt.classList.remove('selected');
      const optColor = opt.getAttribute('data-color');
      if (optColor && optColor.toLowerCase() === color.toLowerCase()) {
        opt.classList.add('selected');
      }
    });

    // Check if color is white
    const isWhiteColor = color && (
      color.toLowerCase() === '#ffffff' ||
      color.toLowerCase() === '#fff' ||
      color.toLowerCase() === 'white' ||
      color.toLowerCase() === 'rgb(255, 255, 255)'
    );

    // Update icon colors in the grid (all icons should reflect the new color)
    if (window.PerfumeCustomizer && window.PerfumeCustomizer.Icons) {
      // Update all icons in the grid
      document.querySelectorAll('#pc-icon-grid .pc-icon-preview').forEach(iconPreview => {
        const svg = iconPreview.querySelector('svg');
        if (svg) {
          window.PerfumeCustomizer.Icons.applyIconColor(svg, color);
        }

        // Update icon preview background to match atomizer color
        const atomizerColorName = this.customization.atomizerColorName || 'Pink';
        const bgColor = this.getAtomizerBackgroundColor(atomizerColorName);
        iconPreview.style.border = '1px solid #e5e7eb';
        iconPreview.style.borderRadius = '4px';
        iconPreview.style.backgroundColor = bgColor;
      });

      // Update icon in preview if it exists
      const previewIcon = document.getElementById('pc-preview-icon');
      if (previewIcon) {
        const svg = previewIcon.querySelector('svg');
        if (svg) {
          window.PerfumeCustomizer.Icons.applyIconColor(svg, color);
        } else {
          // If icon is selected but SVG not loaded yet, reload it with new color
          if (this.customization.iconUrl) {
            const currentColor = this.customization.textColor || '#ffffff';
            window.PerfumeCustomizer.Icons.loadIconSvg(this.customization.iconUrl, previewIcon, currentColor);
          }
        }
      }
    }

    this.updatePreview();

    // Update selected color indicator
    document.querySelectorAll('.pc-color-option').forEach(opt => {
      opt.classList.toggle('selected', opt.dataset.color === color);
    });
  },


  // Update preview
  updatePreview: function () {
    try {
    // Get values from inputs
    const textInput = document.getElementById('pc-text');
    const fontInput = document.getElementById('pc-font');
    const textSizeInput = document.getElementById('pc-text-size');
    const iconSizeInput = document.getElementById('pc-icon-size');

    if (textInput) {
      this.customization.textContent = textInput.value;
    }

    if (fontInput && fontInput.value) {
      this.customization.textFont = fontInput.value;
    }

    if (textSizeInput) {
      let requestedSize = parseInt(textSizeInput.value) || 16;
      
      // Check if this size would exceed text zone at CURRENT POSITION - limit it if needed
      const textContent = this.customization.textContent || '';
      const textZoneElement = document.getElementById('pc-text-zone');
      const textPreviewEl = document.getElementById('pc-preview-text');
      
      if (textZoneElement && textContent && textPreviewEl) {
        const zoneComputedStyle = window.getComputedStyle(textZoneElement);
        const style = textZoneElement.style;
        const zoneHeight = parseFloat(zoneComputedStyle.height) || parseFloat(style.height) || 179;
        const zoneWidth = parseFloat(zoneComputedStyle.width) || parseFloat(style.width) || 84;
        const zoneTop = parseFloat(zoneComputedStyle.top) || parseFloat(style.top) || 0;
        const zoneLeft = parseFloat(zoneComputedStyle.left) || parseFloat(style.left) || 0;
        const zoneBottom = zoneTop + zoneHeight;
        const zoneRight = zoneLeft + zoneWidth;
        
        // Get current position (preserve it)
        let currentTop = parseFloat(textPreviewEl.style.top);
        let currentLeft = parseFloat(textPreviewEl.style.left);
        
        if (isNaN(currentTop) || isNaN(currentLeft)) {
          if (this.customization.textPosition) {
            currentTop = parseFloat(this.customization.textPosition.top);
            currentLeft = parseFloat(this.customization.textPosition.left);
          }
        }
        
        // If no position, center it
        if (isNaN(currentTop) || isNaN(currentLeft)) {
          currentTop = zoneTop + zoneHeight / 2;
          currentLeft = zoneLeft + zoneWidth / 2;
        }
        
        // Get the actual font family from the text element
        let fontFamily = 'inherit';
        const computedStyle = window.getComputedStyle(textPreviewEl);
        fontFamily = computedStyle.fontFamily || 'inherit';
        
        // Calculate what the text dimensions would be at this size
        const tempMeasure = document.createElement('span');
        tempMeasure.style.cssText = `
          position: absolute;
          visibility: hidden;
          white-space: nowrap;
          font-size: ${requestedSize}px;
          font-family: ${fontFamily};
          padding: 0;
          margin: 0;
          line-height: 1.2;
        `;
        tempMeasure.textContent = textContent;
        document.body.appendChild(tempMeasure);
        
        const textWidth = tempMeasure.offsetWidth;
        const textHeight = requestedSize * 1.2;
        document.body.removeChild(tempMeasure);
        
        // When rotated -90deg: width becomes height, height becomes width
        const rotatedHeight = textWidth * 1.1; // Add 10% safety margin
        const rotatedWidth = textHeight * 1.1;
        
        // Calculate text edges at current position with new size
        const textTopEdge = currentTop - rotatedHeight / 2;
        const textBottomEdge = currentTop + rotatedHeight / 2;
        const textLeftEdge = currentLeft - rotatedWidth / 2;
        const textRightEdge = currentLeft + rotatedWidth / 2;
        
        // Check if text would fit at current position
        const wouldFit = textTopEdge >= zoneTop && 
                        textBottomEdge <= zoneBottom && 
                        textLeftEdge >= zoneLeft && 
                        textRightEdge <= zoneRight;
        
        // If text would not fit at current position, find max size that fits
        if (!wouldFit) {
          // Binary search for max size that fits at current position
          let maxSize = requestedSize;
          let testSize = requestedSize;
          let step = Math.max(1, Math.floor(testSize / 4));
          let lastValidSize = 8; // Start with minimum
          
          while (step > 0 && testSize >= 8 && testSize <= 48) {
            const testMeasure = document.createElement('span');
            testMeasure.style.cssText = `
              position: absolute;
              visibility: hidden;
              white-space: nowrap;
              font-size: ${testSize}px;
              font-family: ${fontFamily};
              padding: 0;
              margin: 0;
              line-height: 1.2;
            `;
            testMeasure.textContent = textContent;
            document.body.appendChild(testMeasure);
            
            const testWidth = testMeasure.offsetWidth;
            const testHeight = testSize * 1.2;
            document.body.removeChild(testMeasure);
            
            const testRotatedHeight = testWidth * 1.1;
            const testRotatedWidth = testHeight * 1.1;
            
            // Check if this size fits at current position
            const testTopEdge = currentTop - testRotatedHeight / 2;
            const testBottomEdge = currentTop + testRotatedHeight / 2;
            const testLeftEdge = currentLeft - testRotatedWidth / 2;
            const testRightEdge = currentLeft + testRotatedWidth / 2;
            
            const testFits = testTopEdge >= zoneTop && 
                            testBottomEdge <= zoneBottom && 
                            testLeftEdge >= zoneLeft && 
                            testRightEdge <= zoneRight;
            
            if (testFits) {
              lastValidSize = testSize;
              testSize += step;
            } else {
              testSize -= step;
            }
            step = Math.floor(step / 2);
          }
          
          // Use the last valid size that fits
          maxSize = Math.max(8, Math.min(lastValidSize, 48));
          
          if (requestedSize > maxSize) {
            requestedSize = maxSize;
            textSizeInput.value = maxSize;
          }
        }
      }
      
      this.customization.textSize = requestedSize + 'px';
      const sizeValue = document.getElementById('pc-text-size-value');
      if (sizeValue) {
        sizeValue.textContent = requestedSize + 'px';
      }
      
      // If size was limited, ensure slider reflects the actual size
      if (textSizeInput && parseInt(textSizeInput.value) !== requestedSize) {
        textSizeInput.value = requestedSize;
      }
    }

    if (iconSizeInput) {
      this.customization.iconSize = parseInt(iconSizeInput.value);
      const iconSizeValue = document.getElementById('pc-icon-size-value');
      if (iconSizeValue) {
        iconSizeValue.textContent = iconSizeInput.value + 'px';
      }
    }

    // Update confirmation visibility based on customization

    // Print area constants (DO NOT MODIFY - print area stays as is)
    const PRINT_AREA_WIDTH = 84;
    const PRINT_AREA_HEIGHT = 269;

    // Get preview elements first (needed for zone calculations)
    const iconPreview = document.getElementById('pc-preview-icon');
    const textPreview = document.getElementById('pc-preview-text');
    const previewContent = document.querySelector('.pc-preview-content');
    
    // Zone definitions - read from visual element if it exists
    const textZoneElement = document.getElementById('pc-text-zone');
    let TEXT_ZONE_TOP = 0;
    let TEXT_ZONE_BOTTOM = 179; // Default fallback
    let TEXT_ZONE_LEFT = 0;
    let TEXT_ZONE_RIGHT = 84; // Default fallback
    let TEXT_ZONE_WIDTH = 84;
    let TEXT_ZONE_HEIGHT = 179;

    if (textZoneElement && previewContent) {
      // Use actual element dimensions (relative to preview content)
      TEXT_ZONE_TOP = textZoneElement.offsetTop || 0;
      TEXT_ZONE_LEFT = textZoneElement.offsetLeft || 0;
      TEXT_ZONE_WIDTH = textZoneElement.offsetWidth || 84;
      TEXT_ZONE_HEIGHT = textZoneElement.offsetHeight || 179;
      TEXT_ZONE_BOTTOM = TEXT_ZONE_TOP + TEXT_ZONE_HEIGHT;
      TEXT_ZONE_RIGHT = TEXT_ZONE_LEFT + TEXT_ZONE_WIDTH;
    } else {
      // Fallback to calculated values
      const ICON_ZONE_HEIGHT = 100;
      const TEXT_ZONE_SPACING = 10;
      const ICON_ZONE_TOP = PRINT_AREA_HEIGHT - ICON_ZONE_HEIGHT;
      TEXT_ZONE_BOTTOM = ICON_ZONE_TOP - TEXT_ZONE_SPACING;
      TEXT_ZONE_HEIGHT = TEXT_ZONE_BOTTOM;
      TEXT_ZONE_WIDTH = PRINT_AREA_WIDTH;
    }
    
    const SAFE_MARGIN_MM = 2; // 2mm safe margin around icon
    const SAFE_MARGIN_PX = SAFE_MARGIN_MM * 3.779527559; // Convert mm to px (1mm ≈ 3.78px at 96dpi)
    const MIN_FONT_SIZE = 8;

    // Update icon/logo preview - ICON POSITION IS NEVER CHANGED BY TEXT
    const hasIcon = !!(this.customization.logoUrl || (this.customization.iconUrl && window.PerfumeCustomizer && window.PerfumeCustomizer.Icons));
    const hasText = !!(this.customization.textContent && this.customization.textContent.trim());

    // Add/remove has-icon class from preview content based on icon visibility (for mobile positioning)
    if (previewContent) {
      if (hasIcon) {
        previewContent.classList.add('has-icon');
      } else {
        previewContent.classList.remove('has-icon');
      }
    }

    if (iconPreview) {
      iconPreview.innerHTML = '';

      // Show logo if uploaded
      if (this.customization.logoUrl) {
        iconPreview.style.display = 'flex';
        iconPreview.style.width = this.customization.iconSize + 'px';
        iconPreview.style.height = this.customization.iconSize + 'px';

        // Icon always positioned at bottom center of icon zone (fixed position)
          iconPreview.style.bottom = '13px';
          iconPreview.style.left = '50%';
          iconPreview.style.top = 'auto';
          iconPreview.style.right = 'auto';
          this.customization.iconPosition = { bottom: '13px', left: '50%' };

        iconPreview.style.transform = `translateX(-50%) rotate(-90deg)`;
        iconPreview.style.transition = 'transform 0.3s ease, width 0.3s ease, height 0.3s ease';
        iconPreview.style.alignItems = 'center';
        iconPreview.style.justifyContent = 'center';

        const img = document.createElement('img');
        img.src = this.customization.logoUrl;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        iconPreview.appendChild(img);
      }
      // Show icon if selected
      else if (this.customization.iconUrl && window.PerfumeCustomizer && window.PerfumeCustomizer.Icons) {
        iconPreview.style.display = 'flex';
        iconPreview.style.width = this.customization.iconSize + 'px';
        iconPreview.style.height = this.customization.iconSize + 'px';

        // Icon always positioned at bottom center of icon zone (fixed position)
          iconPreview.style.bottom = '13px';
          iconPreview.style.left = '50%';
          iconPreview.style.top = 'auto';
          iconPreview.style.right = 'auto';
          this.customization.iconPosition = { bottom: '13px', left: '50%' };

        iconPreview.style.transform = `translateX(-50%) rotate(-90deg)`;
        iconPreview.style.transition = 'transform 0.3s ease, width 0.3s ease, height 0.3s ease';
        iconPreview.style.alignItems = 'center';
        iconPreview.style.justifyContent = 'center';
        iconPreview.style.maxWidth = PRINT_AREA_WIDTH + 'px';

        const currentColor = this.customization.textColor || '#ffffff';
        window.PerfumeCustomizer.Icons.loadIconSvg(this.customization.iconUrl, iconPreview, currentColor);
      } else {
        iconPreview.style.display = 'none';
      }
    }

    // Update text preview - TEXT IS INDEPENDENT FROM ICON
    if (textPreview) {
      // Ensure text is visible
      textPreview.style.display = 'block';
      textPreview.style.visibility = 'visible';
      textPreview.style.opacity = '1';

      textPreview.textContent = this.customization.textContent || 'Your Text';
      textPreview.style.fontSize = this.customization.textSize;
      textPreview.style.color = this.customization.textColor;
      textPreview.style.lineHeight = '1.2';
      textPreview.style.setProperty('line-height', '1.2', 'important');

      // For rotated text (-90 degrees), we need to adjust dimensions
      // When rotated, the width becomes the height (vertical length on bottle)
      // Remove maxWidth to allow text to grow until it hits the collision bounds
      textPreview.style.maxWidth = 'none';
      textPreview.style.width = 'auto';
      textPreview.style.minWidth = '0';
      textPreview.style.boxSizing = 'border-box';
      textPreview.style.padding = '0 4px';
      textPreview.style.overflow = 'visible';
      textPreview.style.wordWrap = 'normal';
      textPreview.style.overflowWrap = 'normal';
      textPreview.style.wordBreak = 'normal';
      // Disable wrapping - text should stay on one line and shrink if needed
      textPreview.style.whiteSpace = 'nowrap';
      textPreview.style.textAlign = 'center';

      // Apply font correctly
      if (this.customization.textFont) {
        const fontFamily = this.customization.textFont;
        if (fontFamily.includes(',')) {
          const fontName = fontFamily.split(',')[0].trim();
          const fallbacks = fontFamily.split(',').slice(1).map(f => f.trim()).join(', ');
          textPreview.style.setProperty('font-family', `'${fontName}', ${fallbacks}`, 'important');
        } else {
          textPreview.style.setProperty('font-family', fontFamily, 'important');
        }
      } else {
        textPreview.style.setProperty('font-family', 'inherit', 'important');
      }

      textPreview.style.webkitTextStroke = 'none';
      textPreview.style.textStroke = 'none';
      textPreview.style.textShadow = 'none';

      // Remove width constraint from CSS that might interfere with measurements
      textPreview.style.setProperty('width', 'auto', 'important');
      textPreview.style.setProperty('max-width', 'none', 'important');

      // Text rotation -90 degrees (vertical)
      const textRotationValue = -90;

      // Set transform and other properties
      textPreview.style.setProperty('transform', `translate(-50%, -50%) rotate(${textRotationValue}deg)`, 'important');
      textPreview.style.setProperty('transform-origin', 'center center', 'important');
      textPreview.style.setProperty('bottom', 'auto', 'important');
      textPreview.style.setProperty('right', 'auto', 'important');

      // Ensure text is visible
      textPreview.style.setProperty('display', 'block', 'important');
      textPreview.style.setProperty('visibility', 'visible', 'important');
      textPreview.style.setProperty('opacity', '1', 'important');

      // Get icon status
      const hasIcon = !!(this.customization.logoUrl || (this.customization.iconUrl && window.PerfumeCustomizer && window.PerfumeCustomizer.Icons));
      
      // Preserve current position from DOM first (most accurate)
      let currentTop = parseFloat(textPreview.style.top);
      let currentLeft = parseFloat(textPreview.style.left);
      
      // If not in DOM, try stored position
      if (isNaN(currentTop) || isNaN(currentLeft)) {
      if (this.customization.textPosition) {
          currentTop = parseFloat(this.customization.textPosition.top);
          currentLeft = parseFloat(this.customization.textPosition.left);
        }
      }
      
      // If no position exists yet, center it in text zone first
      if (isNaN(currentTop) || isNaN(currentLeft)) {
        const textZoneElement = document.getElementById('pc-text-zone');
        if (textZoneElement) {
          const zoneComputedStyle = window.getComputedStyle(textZoneElement);
          const style = textZoneElement.style;
          const zoneTop = parseFloat(zoneComputedStyle.top) || parseFloat(style.top) || 0;
          const zoneLeft = parseFloat(zoneComputedStyle.left) || parseFloat(style.left) || 0;
          const zoneHeight = parseFloat(zoneComputedStyle.height) || parseFloat(style.height) || 179;
          const zoneWidth = parseFloat(zoneComputedStyle.width) || parseFloat(style.width) || 84;
          
          // Center in zone
          currentTop = zoneTop + zoneHeight / 2;
          currentLeft = zoneLeft + zoneWidth / 2;
          
          this.customization.textPosition = { top: currentTop + 'px', left: currentLeft + 'px', manual: false };
        }
      }
      
      // Apply the preserved/calculated position
      if (!isNaN(currentTop) && !isNaN(currentLeft)) {
        textPreview.style.setProperty('top', currentTop + 'px', 'important');
        textPreview.style.setProperty('left', currentLeft + 'px', 'important');
      }

      // Force a reflow to ensure all style changes are applied before measuring
      textPreview.offsetHeight;
      
      // Enforce boundaries - but preserve position as much as possible
      // Get original transition to restore later
      const originalTransition = textPreview.style.transition || 'font-size 0.3s ease, color 0.3s ease';
      
      // Enforce boundaries - this will only adjust if text is actually out of bounds
      let enforced = this.enforceTextBoundaries(textPreview, hasIcon);
      
      // Check if position actually changed
      if (enforced) {
        const finalTop = parseFloat(textPreview.style.top);
        const finalLeft = parseFloat(textPreview.style.left);
        const positionChanged = Math.abs(finalTop - currentTop) > 0.1 || Math.abs(finalLeft - currentLeft) > 0.1;
        
        // If position changed, use smooth transition; otherwise keep transitions enabled
        if (positionChanged) {
          // Position was adjusted - use smooth transition for the adjustment
          textPreview.style.setProperty('transition', 'top 0.2s ease-out, left 0.2s ease-out, font-size 0.3s ease, color 0.3s ease', 'important');
          // Force a reflow to trigger transition
          textPreview.offsetHeight;
        }
        
        // Update stored position with enforced values
        if (this.customization.textPosition) {
          this.customization.textPosition.top = enforced.top + 'px';
          this.customization.textPosition.left = enforced.left + 'px';
        }
      }
      
      // Restore original transition after a brief delay to allow smooth adjustment
      setTimeout(() => {
        if (textPreview && textPreview.style) {
          textPreview.style.setProperty('transition', originalTransition, 'important');
        }
      }, 250);
    } else {
      // No text
      if (textPreview) {
        textPreview.style.display = 'none';
      }
    }

    // Zone-based placement ensures no overlap - no collision detection needed
    } catch (error) {
      console.error('Error in updatePreview:', error);
      // Ensure print area is visible even if there's an error
      const printArea = document.getElementById('pc-print-area');
      if (printArea) {
        printArea.style.display = 'block';
        printArea.style.visibility = 'visible';
        printArea.style.opacity = '1';
      }
    }
  },

  // Initialize accordion behavior (desktop + mobile)
  initAccordion: function () {
    const headers = Array.from(document.querySelectorAll('.pc-accordion-header'));
    const contents = Array.from(document.querySelectorAll('.pc-accordion-content'));
    if (!headers.length || !contents.length) return;

    // First, ensure all accordions are closed
    headers.forEach(header => header.classList.remove('active'));
    contents.forEach(content => {
      content.classList.remove('expanded');
      content.style.setProperty('max-height', '0', 'important');
      content.style.setProperty('padding', '0 16px', 'important');
      content.style.setProperty('overflow', 'hidden', 'important');
    });

    // Remove existing event listeners by cloning headers
    headers.forEach(header => {
      const replacement = header.cloneNode(true);
      header.parentNode.replaceChild(replacement, header);
    });

    const refreshedHeaders = Array.from(document.querySelectorAll('.pc-accordion-header'));
    const refreshedContents = Array.from(document.querySelectorAll('.pc-accordion-content'));

    // Ensure all are still closed after cloning
    refreshedHeaders.forEach(header => header.classList.remove('active'));
    refreshedContents.forEach(content => {
      content.classList.remove('expanded');
      content.style.setProperty('max-height', '0', 'important');
      content.style.setProperty('padding', '0 16px', 'important');
      content.style.setProperty('overflow', 'hidden', 'important');
    });

    const closeAll = () => {
      refreshedHeaders.forEach(header => header.classList.remove('active'));
      refreshedContents.forEach(content => {
        content.classList.remove('expanded');
        content.style.setProperty('max-height', '0', 'important');
        content.style.setProperty('padding', '0 16px', 'important');
        content.style.setProperty('overflow', 'hidden', 'important');
      });
    };

    // Match headers with their corresponding content sections using data-accordion attribute
    refreshedHeaders.forEach((header) => {
      const accordionId = header.getAttribute('data-accordion');
      if (!accordionId) return;

      // Find the corresponding content section
      const content = refreshedContents.find(c => c.getAttribute('data-accordion') === accordionId);
      if (!content) return;

      // Toggle function
      const toggleAccordion = (e) => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        // Check if this specific content is expanded
        const isExpanded = content.classList.contains('expanded') && content.style.maxHeight !== '0';

        if (isExpanded) {
          // Close this section
          header.classList.remove('active');
          content.classList.remove('expanded');
          content.style.setProperty('max-height', '0', 'important');
          content.style.setProperty('padding', '0 16px', 'important');
          content.style.setProperty('overflow', 'hidden', 'important');
        } else {
          // Close all sections first
          closeAll();
          // Open this section
          header.classList.add('active');
          content.classList.add('expanded');
          // Temporarily make content visible to calculate scrollHeight
          content.style.maxHeight = 'none';
          content.style.overflow = 'visible';
          content.style.padding = '12px 16px';
          const scrollHeight = content.scrollHeight || 500; // Fallback to 500px if calculation fails
          // Set the actual max-height
          content.style.maxHeight = scrollHeight + 'px';
          content.style.overflow = 'visible';

        }
      };

      // Add click event listener
      header.addEventListener('click', toggleAccordion);

      // Add touch event for mobile (use touchstart to be more responsive)
      let touchStartTime = 0;
      header.addEventListener('touchstart', function (e) {
        touchStartTime = Date.now();
      });

      header.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // Only trigger if it was a quick tap (not a scroll)
        const touchDuration = Date.now() - touchStartTime;
        if (touchDuration < 300) {
          toggleAccordion(e);
        }
      });
    });

    // All sections start closed by default - no section opens automatically
  },

  // Capture preview screenshot (high resolution)
  capturePreviewScreenshot: function () {
    return new Promise((resolve, reject) => {
      try {
        const previewElement = document.querySelector('.pc-individual-preview');
        if (!previewElement) {
          reject(new Error('Preview element not found'));
          return;
        }

        // Detect mobile and adjust scale accordingly
        const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const scale = isMobile ? 2 : 4; // Lower scale on mobile for faster processing
        
        // Wait a bit to ensure all elements are rendered, especially on mobile
        setTimeout(() => {
          // Use html2canvas if available, otherwise use canvas API
          if (typeof html2canvas !== 'undefined') {
            // High resolution capture (lower scale on mobile for performance)
            html2canvas(previewElement, {
              backgroundColor: '#f8fafc', // Match the CSS background color from .pc-individual-preview
              scale: scale, // Lower scale on mobile (2x) vs desktop (4x)
              logging: false,
              useCORS: true,
              allowTaint: true,
              imageSmoothingEnabled: true,
              imageSmoothingQuality: isMobile ? 'medium' : 'high', // Lower quality on mobile for speed
              onclone: (clonedDoc) => {
                // Ensure all elements are visible in the cloned document
                const clonedPreview = clonedDoc.querySelector('.pc-individual-preview');
                if (clonedPreview) {
                  clonedPreview.style.display = 'block';
                  clonedPreview.style.visibility = 'visible';
                  clonedPreview.style.opacity = '1';
                  clonedPreview.style.backgroundColor = '#f8fafc'; // Ensure background is set
                }
                // Ensure atomizer image is visible
                const clonedAtomizer = clonedDoc.querySelector('.pc-preview-atomizer');
                if (clonedAtomizer) {
                  clonedAtomizer.style.display = 'block';
                  clonedAtomizer.style.visibility = 'visible';
                  clonedAtomizer.style.opacity = '1';
                }
                // Ensure print area is visible
                const clonedPrintArea = clonedDoc.querySelector('.pc-print-area');
                if (clonedPrintArea) {
                  clonedPrintArea.style.display = 'block';
                  clonedPrintArea.style.visibility = 'visible';
                  clonedPrintArea.style.opacity = '1';
                }
                // Ensure preview content is visible
                const clonedPreviewContent = clonedDoc.querySelector('.pc-preview-content');
                if (clonedPreviewContent) {
                  clonedPreviewContent.style.display = 'block';
                  clonedPreviewContent.style.visibility = 'visible';
                  clonedPreviewContent.style.opacity = '1';
                }
                // Don't capture the "Your Text" placeholder when no real text was entered
                const clonedTextEl = clonedDoc.querySelector('#pc-preview-text');
                if (clonedTextEl) {
                  const realText = (this.customization.textContent || '').trim();
                  if (!realText) {
                    clonedTextEl.textContent = '';
                    clonedTextEl.style.display = 'none';
                  } else {
                    clonedTextEl.textContent = realText;
                  }
                }
              }
            }).then(canvas => {
              // Use high quality PNG encoding
              const dataURL = canvas.toDataURL('image/png', 1.0);
              resolve(dataURL);
            }).catch(reject);
          } else {
            reject(new Error('html2canvas not loaded'));
          }
        }, 300); // Wait 300ms for elements to render, especially on mobile
      } catch (error) {
        reject(error);
      }
    });
  },

  // Capture print area as PNG (exact dimensions, transparent background)
  capturePrintAreaPNG: function () {
    return new Promise((resolve, reject) => {
      try {
        const printAreaContent = document.querySelector('.pc-preview-content');
        if (!printAreaContent) {
          reject(new Error('Print area content not found'));
          return;
        }

        // Detect mobile and adjust scale accordingly
        const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        // Use html2canvas to capture only the print area content
        if (typeof html2canvas !== 'undefined') {
          // Lower scale on mobile for faster processing (4x vs 8x)
          const scale = isMobile ? 4 : 8;
          const baseWidth = 84;
          const baseHeight = 269;

          html2canvas(printAreaContent, {
            backgroundColor: null, // Transparent background
            scale: scale, // High resolution for printing (8x = 672px × 2152px)
            width: baseWidth, // Base print area width (desktop)
            height: baseHeight, // Base print area height (desktop)
            logging: false,
            useCORS: true,
            allowTaint: true,
            removeContainer: false,
            windowWidth: baseWidth * scale,
            windowHeight: baseHeight * scale,
            onclone: (clonedDoc) => {
              // Ensure print area content has transparent background
              const clonedContent = clonedDoc.querySelector('.pc-preview-content');
              if (clonedContent) {
                clonedContent.style.backgroundColor = 'transparent';
                clonedContent.style.background = 'transparent';
              }
              // Ensure text and icon are visible
              const clonedText = clonedContent?.querySelector('#pc-preview-text');
              const clonedIcon = clonedContent?.querySelector('#pc-preview-icon');
              // Don't bake the "Your Text" placeholder into the print file:
              // only render text the customer actually typed.
              const realText = (this.customization.textContent || '').trim();
              if (clonedText) {
                if (!realText) {
                  clonedText.textContent = '';
                  clonedText.style.display = 'none';
                } else {
                  clonedText.textContent = realText;
                  clonedText.style.display = 'block';
                  clonedText.style.visibility = 'visible';
                  clonedText.style.opacity = '1';
                }
              }
              if (clonedIcon) {
                clonedIcon.style.display = 'flex';
                clonedIcon.style.visibility = 'visible';
                clonedIcon.style.opacity = '1';
              }
            }
          }).then(canvas => {
            // Create final canvas at high resolution
            const finalCanvas = document.createElement('canvas');
            finalCanvas.width = baseWidth * scale;
            finalCanvas.height = baseHeight * scale;
            const ctx = finalCanvas.getContext('2d');
            
            // Clear canvas first to ensure transparency
            ctx.clearRect(0, 0, finalCanvas.width, finalCanvas.height);
 
            // Use high-quality image rendering (lower quality on mobile for speed)
            const isMobileDevice = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = isMobileDevice ? 'medium' : 'high';
 
            // Draw the captured content at full resolution
            ctx.drawImage(canvas, 0, 0, finalCanvas.width, finalCanvas.height);

            // Convert to PNG with transparent background at high quality
            const dataURL = finalCanvas.toDataURL('image/png', 1.0); // Maximum quality
            resolve(dataURL);
          }).catch(reject);
        } else {
          reject(new Error('html2canvas not loaded'));
        }
      } catch (error) {
        reject(error);
      }
    });
  },

  // Generate filename from customization details
  generateImageFilename: function () {
    const product = this.product;
    const customization = this.customization;

    // Get product name (sanitize for filename)
    const productName = (product?.title || 'Perfume')
      .replace(/[^a-zA-Z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 30);

    // Get custom text (sanitize for filename)
    const customText = (customization?.textContent || '')
      .replace(/[^a-zA-Z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 20);

    // Get atomizer color
    const atomizerColor = (customization?.atomizerColorName || 'Pink')
      .replace(/[^a-zA-Z0-9\s-]/g, '')
      .replace(/\s+/g, '-');

    // Get variant title if available
    const variantTitle = this.product?.variants?.find(v => {
      const vId = typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
      return vId === this.variantId;
    })?.title || '';
    const variant = variantTitle
      .replace(/[^a-zA-Z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 10);

    // Build filename: ProductName-CustomText-Color-Variant-Timestamp.png
    const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    const parts = [productName];

    if (customText) parts.push(customText);
    parts.push(atomizerColor);
    if (variant && !variantTitle.includes('Default')) parts.push(variant);
    parts.push(timestamp);

    const filename = parts.join('-') + '.png';
    return filename;
  },

  // Upload PNG to imgbb with custom filename — hardened with retries + per-attempt timeout
  uploadToImgbb: async function (imageBase64, apiKey, filename = null) {
    // Remove data:image/png;base64, prefix if present
    const base64Data = imageBase64.includes(',')
      ? imageBase64.split(',')[1]
      : imageBase64;

    // Convert base64 to Blob once (reused across retries)
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'image/png' });
    const imageFilename = filename || (this.generateImageFilename && this.generateImageFilename()) || 'customization.png';

    const MAX_ATTEMPTS = 3;
    const ATTEMPT_TIMEOUT = 15000; // ms per attempt (aborts a stuck request so we can retry)
    let lastError;

    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), ATTEMPT_TIMEOUT);
      try {
        const formData = new FormData();
        formData.append('key', apiKey);
        formData.append('image', blob, imageFilename);

        const response = await fetch('https://api.imgbb.com/1/upload', {
          method: 'POST',
          body: formData,
          signal: controller.signal
        });
        clearTimeout(timer);

        if (!response.ok) {
          throw new Error('ImgBB HTTP ' + response.status + ' ' + response.statusText);
        }

        const data = await response.json();
        if (data && data.success && data.data) {
          const imageUrl = (data.data.image && data.data.image.url) || data.data.url;
          if (imageUrl) {
            console.log('✅ imgbb upload ok (attempt ' + attempt + '):', imageFilename, imageUrl);
            return imageUrl;
          }
          throw new Error('No URL returned from imgbb');
        }
        throw new Error((data && data.error && data.error.message) || 'imgbb upload failed');
      } catch (error) {
        clearTimeout(timer);
        lastError = error;
        console.warn('imgbb upload attempt ' + attempt + '/' + MAX_ATTEMPTS + ' failed:', error && error.message);
        // Backoff before retrying (1s, then 2s); skip wait after the final attempt
        if (attempt < MAX_ATTEMPTS) {
          await new Promise(function (r) { setTimeout(r, attempt * 1000); });
        }
      }
    }

    console.error('ImgBB upload error after ' + MAX_ATTEMPTS + ' attempts:', lastError && lastError.message);
    throw lastError || new Error('imgbb upload failed after retries');
  },

  // Check if customization exists
  hasCustomization: function () {
    const custom = this.customization || {};
    // Check if there's text, icon, or logo customization
    const hasText = custom.textContent && custom.textContent.trim() !== '';
    const hasIcon = custom.iconFilename && custom.iconFilename.trim() !== '';
    const hasLogo = custom.logoFilename && custom.logoFilename.trim() !== '';
    return hasText || hasIcon || hasLogo;
  },



  // Show disclaimer and wait for user confirmation
  showDisclaimerAndWait: function () {
    return new Promise((resolve, reject) => {
      // Check if popup element exists first
      const popup = document.getElementById('pc-disclaimer-popup');
      if (!popup) {
        console.error('Disclaimer popup element not found in DOM');
        console.warn('Make sure perfume-customizer-disclaimer-popup snippet is rendered on the page');
        // Proceed without disclaimer if popup doesn't exist
        resolve();
        return;
      }
      
      // Show disclaimer popup
      console.log('Attempting to show disclaimer popup...');
      if (window.PerfumeCustomizer && window.PerfumeCustomizer.Individual && window.PerfumeCustomizer.Individual.showDisclaimerPopup) {
        console.log('Using showDisclaimerPopup function');
        window.PerfumeCustomizer.Individual.showDisclaimerPopup();
      } else {
        // Fallback: show popup directly if function doesn't exist
        console.log('showDisclaimerPopup function not found, showing popup directly');
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        const checkbox = document.getElementById('pc-disclaimer-checkbox');
        const confirmBtn = document.getElementById('pc-disclaimer-confirm-btn');
        if (checkbox) {
          checkbox.checked = false;
          // Set up checkbox handler if not already set
          if (!checkbox.dataset.listenerAdded) {
            checkbox.addEventListener('change', () => {
              if (confirmBtn) confirmBtn.disabled = !checkbox.checked;
            });
            checkbox.dataset.listenerAdded = 'true';
          }
        }
        if (confirmBtn) confirmBtn.disabled = true;
      }
        
      // Wait a bit for DOM to update
      setTimeout(() => {
        const confirmBtn = document.getElementById('pc-disclaimer-confirm-btn');
        const checkbox = document.getElementById('pc-disclaimer-checkbox');
        
        if (!confirmBtn || !popup) {
          console.error('Disclaimer popup elements not found after show');
          reject(new Error('Disclaimer popup not properly initialized'));
          return;
        }
        
        // Store resolve function globally so existing handler can access it
        window._disclaimerResolve = resolve;
        window._disclaimerReject = reject;
        
        // Set up checkbox handler if not already set
        if (checkbox && !checkbox.dataset.customizerListenerAdded) {
          checkbox.addEventListener('change', () => {
            const btn = document.getElementById('pc-disclaimer-confirm-btn');
            if (btn) {
              btn.disabled = !checkbox.checked;
            }
          });
          checkbox.dataset.customizerListenerAdded = 'true';
        }
        
        // Remove any existing click handlers to avoid conflicts
        const newConfirmBtn = confirmBtn.cloneNode(true);
        confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
        
        // Add our handler that will close popup and resolve promise
        const handleConfirm = (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const currentCheckbox = document.getElementById('pc-disclaimer-checkbox');
          if (!currentCheckbox || !currentCheckbox.checked) {
            console.log('Checkbox not checked, ignoring click');
            return;
          }
          
          if (!window._disclaimerResolve) {
            console.log('No resolve function available');
            return;
          }
          
          console.log('Closing disclaimer popup and resolving promise');
          
          // Close popup immediately
          const popupEl = document.getElementById('pc-disclaimer-popup');
          if (popupEl) {
            popupEl.style.display = 'none';
            document.body.style.overflow = '';
          }
          
          // Also try using the close function if available
          if (window.PerfumeCustomizer && window.PerfumeCustomizer.Individual && window.PerfumeCustomizer.Individual.closeDisclaimerPopup) {
            window.PerfumeCustomizer.Individual.closeDisclaimerPopup();
          }
          
          // Resolve promise to continue add to cart
          const resolveFn = window._disclaimerResolve;
          window._disclaimerResolve = null;
          window._disclaimerReject = null;
          
          // Use requestAnimationFrame to ensure UI updates before resolving
          requestAnimationFrame(() => {
            setTimeout(() => {
              resolveFn();
            }, 50);
          });
        };
        
        // Add our handler
        newConfirmBtn.addEventListener('click', handleConfirm);
        
        // Handle close button/overlay - reject if user closes without confirming
        const closeBtn = popup.querySelector('.pc-disclaimer-popup-close');
        const overlay = popup.querySelector('.pc-disclaimer-popup-overlay');
        
        const handleCancel = () => {
          if (window._disclaimerReject) {
            const rejectFn = window._disclaimerReject;
            window._disclaimerResolve = null;
            window._disclaimerReject = null;
            rejectFn(new Error('User cancelled disclaimer'));
          }
        };
        
        if (closeBtn) {
          closeBtn.addEventListener('click', handleCancel);
        }
        if (overlay) {
          overlay.addEventListener('click', handleCancel);
        }
      }, 100);
    });
  },

  // Add to cart
  addToCart: async function () {
    console.log('Add to Cart clicked. VariantId:', this.variantId, 'Product:', this.product);

    if (!this.variantId) {
      window.PerfumeCustomizer.Cart.showErrorMessage('Please select a product variant first');
      return;
    }

    // Validate text position before proceeding
    const textValidation = this.validateTextPosition();
    if (!textValidation.valid) {
      window.PerfumeCustomizer.Cart.showErrorMessage(textValidation.message);
      console.warn('Text validation failed:', textValidation);
      return;
    }

    // Ensure cart utility is loaded
    if (!window.PerfumeCustomizer || !window.PerfumeCustomizer.Cart) {
      console.error('Cart utility not loaded');
      alert('Error: Cart functionality not loaded. Please refresh the page.');
      return;
    }

    // Show disclaimer popup and wait for user confirmation
    try {
      // Add timeout to prevent infinite waiting on mobile
      const disclaimerPromise = this.showDisclaimerAndWait();
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Disclaimer timeout')), 60000); // 60 second timeout
      });
      
      await Promise.race([disclaimerPromise, timeoutPromise]);
    } catch (error) {
      console.log('User cancelled disclaimer or error:', error);
      // Close popup if still open
      const popup = document.getElementById('pc-disclaimer-popup');
      if (popup && popup.style.display !== 'none') {
        popup.style.display = 'none';
        document.body.style.overflow = '';
      }
      return; // User cancelled or timeout, don't proceed with add to cart
    }

    const loadingMsg = window.PerfumeCustomizer.Cart.showLoadingMessage('Capturing preview and generating print file...');

    try {
      const IMGBB_API_KEY = 'a19b9be142be2bfd58e700684dc4962e';

      // Detect mobile device
      const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // Capture preview screenshot (high resolution)
      let previewImageUrl = '';
      try {
        // Add timeout for mobile (30 seconds) to prevent getting stuck
        const screenshotPromise = this.capturePreviewScreenshot();
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Screenshot timeout')), isMobile ? 30000 : 60000);
        });
        
        const previewImage = await Promise.race([screenshotPromise, timeoutPromise]);
        console.log('Preview screenshot captured at high resolution');

        // Update loading message
        if (loadingMsg && loadingMsg.update) {
          loadingMsg.update('Uploading preview image...');
        }

        // Generate descriptive filename for preview
        const previewFilename = this.generateImageFilename().replace('.png', '-preview.png');
        console.log('Generated preview filename:', previewFilename);

        // Upload preview to imgbb with custom filename (with timeout)
        const uploadPromise = this.uploadToImgbb(previewImage, IMGBB_API_KEY, previewFilename);
        const uploadTimeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Upload timeout')), 60000);
        });
        
        previewImageUrl = await Promise.race([uploadPromise, uploadTimeoutPromise]);
        console.log('Preview image uploaded to imgbb:', previewImageUrl);
      } catch (screenshotError) {
        console.warn('Failed to capture/upload preview screenshot:', screenshotError);
        // Show user-friendly error but continue
        if (screenshotError.message && screenshotError.message.includes('timeout')) {
          console.warn('Screenshot timed out - continuing without preview image');
        }
        // Continue without preview - don't block the process
      }

      // Capture print area PNG and upload to imgbb (high resolution)
      let printAreaImageUrl = '';
      try {
        // Update loading message
        if (loadingMsg && loadingMsg.update) {
          loadingMsg.update('Capturing print area...');
        }
        
        // Add timeout for mobile
        const printAreaPromise = this.capturePrintAreaPNG();
        const printTimeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Print area capture timeout')), isMobile ? 30000 : 60000);
        });
        
        const printAreaPNG = await Promise.race([printAreaPromise, printTimeoutPromise]);
        console.log('Print area PNG captured at high resolution');

        // Update loading message
        if (loadingMsg && loadingMsg.update) {
          loadingMsg.update('Uploading print file...');
        }

        // Generate descriptive filename for print area
        const printFilename = this.generateImageFilename();
        console.log('Generated print filename:', printFilename);

        // Upload to imgbb with custom filename (with timeout)
        const printUploadPromise = this.uploadToImgbb(printAreaPNG, IMGBB_API_KEY, printFilename);
        const printUploadTimeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('Print upload timeout')), 60000);
        });
        
        printAreaImageUrl = await Promise.race([printUploadPromise, printUploadTimeoutPromise]);
        console.log('Print area PNG uploaded to imgbb:', printAreaImageUrl);
      } catch (printError) {
        console.warn('Failed to capture/upload print area PNG:', printError);
        // Show user-friendly error but continue
        if (printError.message && printError.message.includes('timeout')) {
          console.warn('Print area capture timed out - continuing without print image');
        }
        // Continue without print area image - don't block the process
      }
      
      // Update loading message before proceeding to cart
      if (loadingMsg && loadingMsg.update) {
        loadingMsg.update('Adding to cart...');
      }

      // Prepare customization data
      const customizationData = {
        atomizerColor: this.customization.atomizerColor || '',
        atomizerColorName: this.customization.atomizerColorName || '',
        textContent: this.customization.textContent || '',
        textFont: this.customization.textFont || '',
        textFontName: document.getElementById('pc-font-dropdown-text')?.textContent || '',
        textColor: this.customization.textColor || '#6b7280',
        textSize: this.customization.textSize || '16px',
        textRotation: -90, // Text rotated -90 degrees (vertical)
        iconCategory: this.customization.iconCategory || '',
        iconFilename: this.customization.iconFilename || '',
        iconUrl: this.customization.iconUrl || '',
        iconSize: this.customization.iconSize || 60,
        logoFilename: this.customization.logoFilename || '',
        previewImage: previewImageUrl || '', // Use uploaded URL instead of base64
        previewImageUrl: previewImageUrl || '', // Also store as URL
        printAreaImageUrl: printAreaImageUrl || ''
      };

      // Convert variantId to number if it's a string (Shopify API expects number)
      const variantId = typeof this.variantId === 'string' ? parseInt(this.variantId, 10) : this.variantId;

      if (isNaN(variantId)) {
        throw new Error('Invalid variant ID');
      }

      // Create cart item - minimize properties to avoid "Cart is too large" error
      // Shopify has limits on cart item properties (max 100 properties, max 5000 chars total)
      const variantTitle = this.product?.variants?.find(v => {
        const vId = typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
        return vId === variantId;
      })?.title || 'Default';

      // Check if customization exists based on customizationData (what we're actually adding to cart)
      // Check if there's text, icon, or logo customization (excluding empty strings and default values)
      // Use !! to ensure boolean values, not empty strings
      const hasText = !!(customizationData.textContent && customizationData.textContent.trim() !== '');
      const hasIcon = !!(customizationData.iconFilename && customizationData.iconFilename.trim() !== '');
      const hasLogo = !!(customizationData.logoFilename && customizationData.logoFilename.trim() !== '');
      const hasCustomization = hasText || hasIcon || hasLogo;

      console.log('🔍 Customization check:', {
        hasCustomization: hasCustomization,
        hasText: hasText,
        hasIcon: hasIcon,
        hasLogo: hasLogo,
        textContent: customizationData.textContent,
        iconFilename: customizationData.iconFilename,
        logoFilename: customizationData.logoFilename,
        customizationObject: this.customization
      });

      // Only include essential properties, skip long URLs if they exceed limits
      const properties = {
        'Order Type': 'Individual Custom Perfume',
        'Atomizer Color': (customizationData.atomizerColorName || 'Pink').substring(0, 100),
        'Custom Text': (customizationData.textContent || 'None').substring(0, 100),
        'Custom Font': (customizationData.textFontName || 'Default').substring(0, 50),
        'Custom Color': (customizationData.textColor || 'Default').substring(0, 20),
        'Text Rotation': '-90°', // Text rotated -90 degrees (vertical)
        'Custom Icon': customizationData.iconFilename ? `${customizationData.iconCategory}/${customizationData.iconFilename}`.substring(0, 100) : 'None',
        'Icon Size': (customizationData.iconSize || 60) + 'px',
        'Product Title': (this.product?.title || '').substring(0, 100),
        'Variant Title': variantTitle.substring(0, 50)
      };

      // Only add customization fee property if customization exists
      if (hasCustomization) {
        properties['Customization Fee'] = '$4.99';
      }

      // Add preview image URL if available (prefer print area, fallback to preview)
      // Use printAreaImageUrl for the actual print file, or previewImageUrl as fallback
      const previewUrl = customizationData.printAreaImageUrl || customizationData.previewImageUrl;
      if (previewUrl && previewUrl.trim() !== '') {
        // ImgBB URLs are typically under 200 chars, safe to add
        if (previewUrl.length < 1000) {
          properties['Preview Image URL'] = previewUrl;
        } else {
          // If URL is too long, truncate it but keep it functional
          properties['Preview Image URL'] = previewUrl.substring(0, 1000);
        }
        console.log('✅ Preview Image URL added to cart properties:', previewUrl);
      } else {
        console.warn('⚠️ Preview Image URL is empty or not available');
      }

      const cartItem = {
        id: variantId,
        quantity: 1,
        properties: properties
      };

      console.log('Adding to cart:', cartItem);
      console.log('Preview Image URL:', previewUrl || 'Not available');

      // Verify config is loaded
      console.log('🔧 PerfumeCustomizer Config:', window.PerfumeCustomizer?.config);
      console.log('🔧 Fee Variant ID from config:', window.PerfumeCustomizer?.config?.customizationFeeVariantId);

      // Add main product to cart
      const mainItemResult = await window.PerfumeCustomizer.Cart.addSingleItemToCart(cartItem);
      console.log('✅ Main product added to cart:', mainItemResult);

      // Add customization fee as separate line item ONLY if customization exists
      // Note: Shopify doesn't allow direct price modification, so we need a separate product/variant for the fee
      let feeAddedSuccessfully = false;
      console.log('💰 Fee addition check:', {
        hasCustomization: hasCustomization,
        config: window.PerfumeCustomizer?.config,
        customizationFeeVariantId: window.PerfumeCustomizer?.config?.customizationFeeVariantId
      });

      if (hasCustomization) {
        let customizationFeeVariantId = window.PerfumeCustomizer?.config?.customizationFeeVariantId;
        console.log('💰 Customization fee variant ID from config:', customizationFeeVariantId, typeof customizationFeeVariantId);

        // If customizationFeeVariantId looks like a product ID (might be wrong), try to fetch the product
        // Product IDs and variant IDs can be similar, so we need to verify
        if (customizationFeeVariantId) {
          try {
            // First, try the direct variant ID
            let feeVariantId = customizationFeeVariantId;
            if (typeof feeVariantId === 'string') {
              feeVariantId = parseInt(feeVariantId, 10);
              if (isNaN(feeVariantId)) {
                throw new Error(`Invalid variant ID format: ${customizationFeeVariantId}`);
              }
            }

            // Try to verify if this is actually a variant or product ID
            // We'll attempt to add it, and if it fails with specific errors, try fetching the product
            console.log('💰 Processed fee variant ID:', feeVariantId, typeof feeVariantId);
            console.log('💰 Fee variant ID value:', feeVariantId);

            const feeItem = {
              id: feeVariantId,
              quantity: 1,
              properties: {
                'Order Type': 'Customization Fee',
                'Associated Product': (this.product?.title || '').substring(0, 100),
                'Associated Variant': variantTitle.substring(0, 50)
              }
            };

            console.log('🔄 Adding customization fee to cart:', JSON.stringify(feeItem, null, 2));

            // Try adding the fee directly to get better error messages
            try {
              const feeResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(feeItem)
              });

              console.log('Fee add response status:', feeResponse.status, feeResponse.statusText);

              if (feeResponse.ok) {
                const feeResult = await feeResponse.json();
                console.log('✅ Customization fee ($4.99) successfully added to cart:', feeResult);
                feeAddedSuccessfully = true;
              } else {
                const errorText = await feeResponse.text();
                console.error('❌ Fee add failed with status:', feeResponse.status);
                console.error('❌ Fee error response text:', errorText);

                // If we get a cart error, try fetching the product to find the correct variant
                if (feeResponse.status === 422 || feeResponse.status === 404) {
                  console.log('🔍 Variant ID might be a product ID, trying to fetch product variants...');
                  try {
                    // Try to fetch product by ID or handle - first try as product ID in products.json
                    // Note: Shopify /products/{id}.js only works with handles, not IDs
                    // But we can try searching products.json
                    const productsResponse = await fetch('/products.json?limit=250');
                    if (productsResponse.ok) {
                      const productsData = await productsResponse.json();
                      // Look for "Customization Fee" product
                      const feeProduct = productsData.products.find(p =>
                        p.title.toLowerCase().includes('customization') ||
                        p.title.toLowerCase().includes('fee') ||
                        p.id === feeVariantId ||
                        p.variants?.some(v => v.id === feeVariantId)
                      );

                      if (feeProduct) {
                        console.log('✅ Found Customization Fee product:', feeProduct.title, feeProduct.handle);
                        // Get the first available variant
                        const firstVariant = feeProduct.variants?.find(v => v.available) || feeProduct.variants?.[0];
                        if (firstVariant) {
                          console.log('✅ Found variant ID:', firstVariant.id, 'Title:', firstVariant.title);
                          feeVariantId = firstVariant.id;
                          customizationFeeVariantId = firstVariant.id; // Update for retry

                          // Retry with the correct variant ID
                          const retryItem = {
                            id: feeVariantId,
                            quantity: 1,
                            properties: feeItem.properties
                          };

                          console.log('🔄 Retrying with variant ID:', feeVariantId);
                          const retryResponse = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                              'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: JSON.stringify(retryItem)
                          });

                          if (retryResponse.ok) {
                            const retryResult = await retryResponse.json();
                            console.log('✅ Customization fee ($4.99) successfully added to cart with correct variant ID:', retryResult);
                            feeAddedSuccessfully = true;
                            // Update config for future use
                            if (window.PerfumeCustomizer?.config) {
                              window.PerfumeCustomizer.config.customizationFeeVariantId = feeVariantId;
                              console.log('✅ Updated config with correct variant ID:', feeVariantId);
                            }
                          } else {
                            const retryError = await retryResponse.text();
                            console.error('❌ Retry also failed:', retryError);
                            throw new Error(`Failed to add customization fee even with variant ID ${feeVariantId}. Error: ${retryError}`);
                          }
                        } else {
                          throw new Error(`Product found but no variants available. Product: ${feeProduct.title}`);
                        }
                      } else {
                        throw new Error(`Could not find "Customization Fee" product. Please verify the product exists.`);
                      }
                    }
                  } catch (fetchError) {
                    console.error('Error fetching product variants:', fetchError);
                    // Continue with original error
                  }
                }

                // If we didn't successfully retry, throw the original error
                if (!feeAddedSuccessfully) {
                  // Try to parse error JSON for more details
                  let errorMessage = errorText;
                  let errorDetails = {};
                  try {
                    const errorJson = JSON.parse(errorText);
                    errorMessage = errorJson.message || errorJson.description || errorJson.errors || errorText;
                    errorDetails = errorJson;

                    // Log detailed error information
                    if (errorJson.errors) {
                      console.error('❌ Detailed error:', errorJson.errors);
                    }
                    if (errorJson.description) {
                      console.error('❌ Error description:', errorJson.description);
                    }
                  } catch (e) {
                    // Not JSON, use text as is
                    console.error('Error response is not JSON:', errorText);
                  }

                  // Provide more helpful error message based on status code
                  let helpfulMessage = errorMessage;
                  if (feeResponse.status === 422) {
                    helpfulMessage = `Variant ${feeVariantId} may not exist, be unavailable, or out of stock. Error: ${errorMessage}. The ID ${feeVariantId} might be a product ID instead of a variant ID. Please check the product page in Shopify admin and find the variant ID.`;
                  } else if (feeResponse.status === 404) {
                    helpfulMessage = `Variant ${feeVariantId} not found. This might be a product ID. Please check the "Customization Fee" product in Shopify admin, click on the variant, and find the variant ID from the URL or variant details.`;
                  } else if (feeResponse.status === 400) {
                    helpfulMessage = `Invalid request. Please verify variant ${feeVariantId} exists and is available for purchase. Error: ${errorMessage}`;
                  }

                  throw new Error(helpfulMessage);
                }
              }
            } catch (fetchError) {
              // Re-throw to be caught by outer catch block
              throw fetchError;
            }

            // Small delay to ensure Shopify processes both additions
            await new Promise(resolve => setTimeout(resolve, 300));
          } catch (feeError) {
            console.error('❌ Failed to add customization fee:', feeError);
            console.error('❌ Fee error stack:', feeError.stack);
            // Try to get more details about the error
            const errorMessage = feeError.message || feeError.toString();
            console.error('Fee error details:', errorMessage);

            // Provide user-friendly error message
            const userMessage = `Warning: Customization fee ($4.99) could not be added. ${errorMessage}. Please verify the "Customization Fee" product variant (ID: ${customizationFeeVariantId}) exists and is available for purchase in Shopify admin.`;
            window.PerfumeCustomizer.Cart.showErrorMessage(userMessage);

            // Log detailed error for debugging
            console.error('🔍 Troubleshooting:');
            console.error('1. Verify variant ID:', customizationFeeVariantId);
            console.error('2. Check if variant exists in Shopify admin');
            console.error('3. Verify variant is published and available');
            console.error('4. Check if variant has inventory or inventory tracking disabled');
          }
        } else {
          console.warn('⚠️ Customization fee variant ID not configured. Config object:', window.PerfumeCustomizer?.config);
          window.PerfumeCustomizer.Cart.showErrorMessage('Warning: Customization fee variant ID not configured. The $4.99 fee may not be added to your cart total.');
        }
      } else {
        console.log('⚠️ No customization detected, skipping customization fee');
        console.log('Customization object:', this.customization);
      }

      // Verify fee was added if customization exists
      if (hasCustomization) {
        try {
          // Wait a bit for cart to update
          await new Promise(resolve => setTimeout(resolve, 500));

          const verifyCartResponse = await fetch('/cart.js');
          const verifyCart = await verifyCartResponse.json();

          console.log('🔍 Verifying cart after fee addition. Total items:', verifyCart.items.length);
          console.log('🔍 Cart items:', verifyCart.items.map(item => ({
            id: item.id,
            title: item.product_title,
            variant_title: item.variant_title,
            price: item.price / 100,
            properties: item.properties
          })));

          // Check if fee item exists in cart
          const feeItemInCart = verifyCart.items.find(item =>
            item.properties &&
            item.properties['Order Type'] === 'Customization Fee'
          );

          if (feeItemInCart) {
            console.log('✅ Customization fee verified in cart!');
            console.log('✅ Fee item:', {
              id: feeItemInCart.id,
              title: feeItemInCart.product_title,
              price: feeItemInCart.price / 100,
              quantity: feeItemInCart.quantity
            });
            console.log('✅ Cart total:', verifyCart.total_price / 100);
            feeAddedSuccessfully = true; // Mark as successful if found in cart
          } else {
            console.warn('⚠️ Customization fee NOT found in cart after addition attempt.');
            console.warn('⚠️ Fee was marked as added:', feeAddedSuccessfully);
            console.warn('⚠️ Cart items:', verifyCart.items.map(item => ({
              id: item.id,
              title: item.product_title,
              properties: item.properties?.['Order Type'] || 'No Order Type'
            })));

            // If fee wasn't added but customization exists, show warning
            if (!feeAddedSuccessfully) {
              console.error('❌ CRITICAL: Customization fee was not added to cart!');
              window.PerfumeCustomizer.Cart.showErrorMessage('Warning: Customization fee ($4.99) was not added to cart. Please check console for details.');
            }
          }
        } catch (verifyError) {
          console.warn('Could not verify fee in cart:', verifyError);
        }
      } else {
        console.log('ℹ️ No customization detected, fee addition skipped.');
      }

      if (loadingMsg && typeof loadingMsg.remove === 'function') {
        loadingMsg.remove();
      } else if (loadingMsg && loadingMsg.parentNode) {
        loadingMsg.parentNode.removeChild(loadingMsg);
      }

      // Refresh cart and update sidebar
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Update sidebar cart using theme's method
        if (typeof jQuery !== 'undefined' && typeof scoder !== 'undefined' && typeof scoder.updateSidebarCart === 'function') {
          scoder.updateSidebarCart(cart);
        } else {
          // Fallback: Fetch cart HTML and update sidebar
          const cartHtmlResponse = await fetch('/cart?view=ajax_side_cart');
          if (cartHtmlResponse.ok) {
            const cartHtml = await cartHtmlResponse.text();
            const sidebarContent = document.querySelector('#scoder-cart-sidebar .scoder-sidebar-wrapper .previewCart-wrapper, .cart-sidebar .cart-content, [data-cart-content]');
            if (sidebarContent) {
              sidebarContent.innerHTML = cartHtml;
            }
          }
        }

        // Update cart count
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
        cartCountElements.forEach(el => {
          if (el) el.textContent = cart.item_count || 0;
        });

        // Dispatch cart updated events
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      } catch (cartError) {
        console.warn('Error refreshing cart:', cartError);
      }

      window.PerfumeCustomizer.Cart.showSuccessMessage('Customized perfume added to cart!');
      window.PerfumeCustomizer.Cart.triggerCartSidebar();

      // Close modal
      this.close();
    } catch (error) {
      console.error('Individual Customizer: Error adding to cart:', error);

      if (loadingMsg && typeof loadingMsg.remove === 'function') {
        loadingMsg.remove();
      } else if (loadingMsg && loadingMsg.parentNode) {
        loadingMsg.parentNode.removeChild(loadingMsg);
      }

      // Check if it's a "Cart is too large" error
      let errorMessage = error.message || 'Failed to add item to cart. Please try again.';
      if (error.message && error.message.includes('too large')) {
        errorMessage = 'Cart item properties are too large. Please try with fewer customizations or contact support.';
      } else if (error.message && error.message.includes('422')) {
        errorMessage = 'Unable to add item to cart. The customization data may be too large. Please try again or contact support.';
      }
      window.PerfumeCustomizer.Cart.showErrorMessage(`Error: ${errorMessage}`);
    }
  }
};


// Close on escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    window.PerfumeCustomizer.Individual.close();
  }
});

// Close on backdrop click
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('pc-individual-modal');
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target.id === 'pc-individual-modal') {
        window.PerfumeCustomizer.Individual.close();
      }
    });
  }

  // Ensure close button works on mobile
  const closeButtons = document.querySelectorAll('.pc-individual-close');
  closeButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.PerfumeCustomizer?.Individual?.close) {
        window.PerfumeCustomizer.Individual.close();
      }
    });

    btn.addEventListener('touchend', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.PerfumeCustomizer?.Individual?.close) {
        window.PerfumeCustomizer.Individual.close();
      }
    });
  });

  // Mobile accordion functionality (only on mobile)
  if (window.PerfumeCustomizer?.Individual?.initAccordion) {
    window.PerfumeCustomizer.Individual.initAccordion();
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.PerfumeCustomizer?.Individual?.initAccordion) {
        window.PerfumeCustomizer.Individual.initAccordion();
      }
    }, 250);
  });
});
